<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
        <a [routerLink]="['/']">Home</a>
    </li>
    <li>
        <a [routerLink]="['/meeting']">Meeting</a>
    </li>
    <li *ngIf="!restrictTabFlag">Schedule Circular Resolution</li>
    <li *ngIf="restrictTabFlag">Edit Circular Resolution</li>
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
          <strong>{{titleOnAddUpdate}}</strong>
      </span>
      <span style="float: right">
              <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
                  <i class=" fa fa-chevron-circle-left"></i>
                  Back
              </button>
      </span>
  </div>
  <div class="row">
    <div class="col-lg-12" id="meetingTabContainer">
      <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
              <a class="nav-link {{meetingActive}}" href="javascript: void(0);" data-toggle="tab"
                  data-target="#MeetingDetails" aria-selected="IsMeetingDetailsActive" role="tab">Details
              </a>
          </li>
      
          <li class="nav-item" (click)="adjustDirectorTable()">
              <a *ngIf="restrictTabFlag" class="nav-link {{directorActive}}" href="javascript: void(0);"
                  data-toggle="tab" data-target="#Directors" aria-selected="IsDirectorsTabActive"
                  role="tab">{{directorTabName}}</a>
          </li>
          <li class="nav-item">
              <a *ngIf="restrictTabFlag" class="nav-link {{invitteeActive}}" href="javascript: void(0);"
                  data-toggle="tab" data-target="#Invitees" aria-selected="IsInviteesTabActive"
                  role="tab">Invitees</a>
          </li>
         
          <li class="nav-item">
              <a *ngIf="restrictTabFlag" class="nav-link {{documentActive}}" href="javascript: void(0);"
                  data-toggle="tab" data-target="#DocumentStampGenerator"
                  aria-selected="IsDocumentStampGeneratorTabActive" role="tab">Document</a>
          </li>
          <li class="nav-item">
              <a *ngIf="restrictTabFlag" class="nav-link {{documentActive}}" href="javascript: void(0);"
                  data-toggle="tab" data-target="#response"
                  aria-selected="IsDocumentStampGeneratorTabActive" role="tab">Response Sheet</a>
          </li>
      </ul>
      <div class="tab-content">
  
          <!-- Add/Edit Form -->
          <div class="tab-pane {{meetingActive}}" id="MeetingDetails" role="tabcard">
              <!-- Add Meeting Form -->
              <form [formGroup]="addmeetingForm" class="well" (document:click)="a.close();b.close(); "
                  NoValidate>
  
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-lg-2">
                              <label class="form-control-label">Type</label>
                              <span _ngcontent-c2="" style="color: red;">*</span>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <select class="form-control"
                                      [formControl]="addmeetingForm.controls['MeetingType']" style="padding:6px;"
                                      (change)="membersAndProcess($event);" required="required">
                                      <option value='' [selected]="true">Select</option>
                                      <option *ngFor="let meetingTypeList of meetingTypes" id="meetingTypeName"
                                          [value]="meetingTypeList._id">
                                          {{meetingTypeList.MeetingType}}
                                      </option>
                                  </select>
                                  <!-- Start Error Message -->
                                  <div *ngIf="addmeetingForm.controls['MeetingType'].hasError('required') && addmeetingForm.controls['MeetingType'].touched"
                                      class="form-control-error-custom">
                                       Type is required.
                                  </div>
                                  <!-- End Error Message -->
                              </div>
                          </div>
  
                          <div class="col-lg-2">
                              <label class="form-control-label">CR Number</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <!-- <input type="text" [formControl]="addmeetingForm.controls['MeetingNumber']" (keydown)="onlyNumber($event)" class="form-control"
                                          style="padding:6px;"> -->
                                  <input type="text" [formControl]="addmeetingForm.controls['MeetingNumber']"
                                      class="form-control" style="padding:6px;">
                              </div>
                          </div>
  
                          <div class="col-lg-2">
                              <label class="form-control-label" for="l0">Date of Dispatch</label>
                               <span _ngcontent-c2="" style="color: red;">*</span>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <div class="input-group" (click)="$event.stopPropagation();">
                                      <input class="form-control" 
                                          [formControl]="addmeetingForm.controls['MeetingDate']"
                                          [minDate]="dateOfIncorpOfCompany" [(ngModel)]="MeetingDateModel"
                                          placeholder="dd-mm-yyyy" name="MeetingDate" ngbDatepicker
                                          #a="ngbDatepicker"
                                          (click)="a.toggle();b.close();setDateOfSigning();"
                                          (ngModelChange)="setDateOfSigning();">
                                      <button class="input-group-addon"
                                          (click)="a.toggle();b.close();setDateOfSigning();"
                                          type="button">
                                          <span class="fa fa-calendar"></span>
                                      </button>
                                  </div>
                                  <!-- Start Error Message -->
                                   <div *ngIf="addmeetingForm.controls['MeetingDate'].hasError('required') && addmeetingForm.controls['MeetingDate'].touched"
                                      class="form-control-error-custom">
                                      Date of Dispatch is required.
                                  </div>
                                  <!-- End Error Message -->
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">Name of person signing Notice</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text"
                                      [formControl]="addmeetingForm.controls['NoticeSignatoryName']"
                                      class="form-control" style="padding:6px;">
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">Mobile Number</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input [formControl]="addmeetingForm.controls['ContactNumber']"
                                      class="form-control" pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                                  <div *ngIf="addmeetingForm.controls['ContactNumber'].hasError('pattern') && addmeetingForm.controls['ContactNumber'].touched"
                                      class="form-control-error-custom">
                                      Mobile Number is not valid.
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">Email address</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                      [formControl]="addmeetingForm.controls['EmailID']" class="form-control"
                                      style="padding:6px;">
                                  <!-- Start Error Message -->
                                  <div *ngIf="addmeetingForm.controls['EmailID'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Mail id not valid.
                                  </div>
                                  <!-- End Error Message -->
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">Designation of person signing Notice</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text"
                                      [formControl]="addmeetingForm.controls['NoticeSignatoryDesignation']"
                                      class="form-control" style="padding:6px;">
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">DIN / ACS no.</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" [formControl]="addmeetingForm.controls['DinNumber']"
                                      class="form-control" style="padding:6px;" (keydown)="DinNumber($event)">
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label" for="l0">Date of signing Notice</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <div class="input-group" (click)="$event.stopPropagation()">
                                      <input class="form-control"
                                          [formControl]="addmeetingForm.controls['SigningNoticeDate']"
                                          [(ngModel)]="SigningNoticeDateModel" style="padding:6px;z-index: 0;"
                                          placeholder="dd-mm-yyyy" name="SigningNoticeDate"
                                          [maxDate]="MeetingDateModel" ngbDatepicker #b="ngbDatepicker"
                                          (click)="b.toggle();a.close();">
                                      <button class="input-group-addon" (click)="b.toggle();a.close();"
                                          type="button">
                                          <span class="fa fa-calendar"
                                              style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                      </button>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">Place of signing Notice</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" [formControl]="addmeetingForm.controls['SigningNoticePlace']"
                                      class="form-control" style="padding:6px;">
                              </div>
                          </div>
                          
                      </div>
                  </div>
  
  
                  <div class="modal-footer">
  
                      <button id="btnSaveMeeting" *ngIf="!environmentSettings.PSS" type="button"
                          class="btn btn-sm btn-primary"
                          [disabled]="meetingFreezeStatus || !addmeetingForm.valid || disabledOnclick"
                          (click)="addAndUpdateMeetingWithPublish(saveOrUpdate=='Update' ? meetingDetails.meetingData[0].isPublished:false)">
                          <i class="fa fa-save"></i>&nbsp;{{saveOrUpdate}}
                      </button>
  
                      <button type="button" class="btn-sm btn btn-default" data-toggle="modal"
                          *ngIf="!restrictTabFlag" data-target="#clearMeetingDataModal">
                          <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                  </div>
  
                  <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static"
                      data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
                      <div class="modal-dialog" role="document">
                          <div class="modal-content">
                              <div id="alertTitle" class="modal-header"
                                  style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                  Title!
                              </div>
                              <div class="modal-body">
                                  <div id="alertMessage">
                                      Message..
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
  
                  <div class="modal fade" id="clearMeetingDataModal" tabindex="-1" role="dialog"
                      data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                          <div class="modal-content">
                              <div class="modal-header">
                                  <h5 class="modal-title" id="myModalLabelForDelete">
                                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                      <i class="fa fa-times"></i>
                                  </button>
                              </div>
                              <div class="modal-body">
                                  <div class="row">
                                      <div class="col-sm-12">
                                          Are you sure you want to clear circular details?
                                      </div>
                                  </div>
                              </div>
                              <div class="modal-footer">
                                  <button type="button" class="btn btn-sm btn-danger" (click)="back()"
                                      data-dismiss="modal">
                                      <i class="fa fa-check"></i>&nbsp;Yes</button>
                                  <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                      <i class="fa fa-times"></i>&nbsp;No</button>
                              </div>
                          </div>
                      </div>
                  </div>
  
  
                  
              </form>
              <!-- End Add Meeting Form -->
          </div>
  
          <!-- Category Data -->
          <div class="tab-pane {{categoryActive}}" id="CategoryTab" role="tabcard">
              <div class="loader" align="center" *ngIf="loading1">
                  <div>
                      <!-- -->
                  </div>
              </div>
              <section class="card" [ngStyle]="{'opacity':loading1 === true ? 0.5 : 1}">
                  <div class="card-header">
                      <span class="cat__core__title">
                          Category
                      </span>
                      <span style="float: right">
                          <button type="button" class="btn btn-sm btn-primary" (click)="addCategoryPopup()"
                              data-toggle="modal" data-target="#categoryDialog"
                              [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}"
                              [disabled]="meetingFreezeStatus">
                              <i class="fa fa-plus"></i>&nbsp;Category</button>
                      </span>
                  </div>
  
                  <div class="card-block datatable-card-block">
                      <div class="col-lg-12">
                          <div class="table-responsive ">
                              <table id="addingCategoryTable" datatable [dtOptions]="dtOptionsOfCategory"
                                  [dtTrigger]="dtTriggerOfCategory"
                                  class="table table-hover compact cell-border nowrap stripe"
                                  style="cursor: pointer;">
                                  <!--  -->
                                  <thead>
                                      <tr>
                                          <th>Category Name</th>
                                          <th class="category-list-company-global">Company / Global</th>
                                          <th class="category-list-action">
                                              Action
                                          </th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr *ngFor="let category of AgendaCategory;  let count=index">
                                          <td tabindex="1">{{category.CategoryName }}</td>
                                          <td tabindex="2" class="category-list-company-global">
                                              <span *ngIf="category.IsGlobal">Global</span>
                                              <span *ngIf="!category.IsGlobal">Company Specific</span>
                                          </td>
                                          <td class="category-list-action">
                                              <button type="button" class="btn-sm btn btn-danger"
                                                  (click)="categoryDeleteConFirmation(category)">
                                                  <span class="icmn-bin"></span>
                                              </button>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </section>
  
          </div>
  
  
  
          <!-- Category Modal -->
          <div class="modal fade modal-size-large" id="categoryDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel">
                              <i class="fa fa-plus"></i>&nbsp;Category</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="card-block datatable-card-block">
                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="margin-bottom-50">
                                          <div class="table-responsive">
                                              <table datatable [dtOptions]="dtOptionsOfCategoryPopup"
                                                  [dtTrigger]="dtTriggerOfCategoryPopup"
                                                  class="table table-hover compact cell-border nowrap stripe"
                                                  id="categoryTablePopup" style="cursor: pointer;">
                                                  <thead>
                                                      <tr>
                                                          <th style="width: 10%;">
                                                              <div class="md-checkbox">
                                                                  <input id="selectCategoryPopUpAll"
                                                                      type="checkbox"
                                                                      (change)="checkAllCategory($event)"
                                                                      [(ngModel)]="selectedAllCategory">
                                                                  <label
                                                                      for="selectCategoryPopUpAll">&nbsp;</label>
                                                              </div>
                                                          </th>
                                                          <th style="width: 65%;">Category Name</th>
                                                          <th class="category-list-company-global"
                                                              style="width: 25%;">Company / Global</th>
                                                          <th style="display: none;">Category </th>
                                                      </tr>
                                                  </thead>
                                                  <tbody>
                                                      <ng-container
                                                          *ngFor="let category of categoryPopupArray;  let count=index">
                                                          <tr *ngIf="category.isDefault!=true">
                                                              <td style="width: 10%;"
                                                                  class="category-list-action">
                                                                  <div class="md-checkbox">
                                                                      <input id="selectPopUpCategory{{count +1 }}"
                                                                          type="checkbox"
                                                                          [(ngModel)]="category.IsSelectedCategory"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          (change)="checkCategory($event,category)">
                                                                      <label
                                                                          for="selectPopUpCategory{{count +1 }}">&nbsp;</label>
                                                                  </div>
                                                              </td>
                                                              <td style="width: 65%;" tabindex="1">
                                                                  {{category.CategoryName }}
                                                              </td>
                                                              <td style="width: 25%;" tabindex="2"
                                                                  class="category-list-company-global">
                                                                  <span *ngIf="category.IsGlobal">Global</span>
                                                                  <span *ngIf="!category.IsGlobal">Company
                                                                      Specific
                                                                  </span>
                                                              </td>
                                                              <td style="display: none;">{{category._id }}</td>
                                                          </tr>
                                                      </ng-container>
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button id="btnsaveAgenda" type="button" (click)="addSelectedCategory()"
                              class="btn-sm btn btn-primary" [disabled]="!cheackCategory || disabledOnclick">
                              <i class="fa fa-save"></i>&nbsp;Add Category
                          </button>
                          <button type="button" class="btn btn-sm" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;Close
                          </button>
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- Agenda Data -->
          <div class="tab-pane {{agendaActive}}" id="AgendTab" role="tabcard">
              <div class="loader" align="center" *ngIf="loading">
                  <div>
                      <!-- -->
                  </div>
              </div>
              <section class="card" [ngStyle]="{'opacity':loading === true ? 0.5 : 1}">
                  <div class="card-header">
                      <span class="cat__core__title">
                          Agenda
                      </span>
                      <span style="float: right">
                          <div class="btn-group" role="group" aria-label="Basic example">
                              <button type="button" class="btn btn-sm btn-primary"
                                  (click)="addAgendaPageRedirection()"
                                  [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}"
                                  [disabled]="meetingFreezeStatus">
                                  <i class="fa fa-plus"></i>&nbsp; Add Agenda</button>
                              <button type="button" class="btn btn-sm btn-primary"
                                  (click)="getAgendaLibraryList()" data-toggle="modal"
                                  data-target="#agendaStoreDialog"
                                  [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}"
                                  [disabled]="meetingFreezeStatus">
                                  <i class="fa fa-plus"></i>&nbsp; Agenda Library</button>
                              <button type="button" class="btn btn-sm btn-primary"
                                  (click)="getOpenAgendaAgendaList()" data-toggle="modal"
                                  data-target="#agendaStoreDialog"
                                  [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}"
                                  [disabled]="meetingFreezeStatus">
                                  <i class="fa fa-plus"></i>&nbsp; Open Agenda</button>
                          </div>
                      </span>
                  </div>
  
                  <div class="card-block datatable-card-block">
                      <div class="col-lg-12">
                          <div class="table-responsive ">
                              <table datatable [dtOptions]="dtAgendaOptions" [dtTrigger]="dtTriggerAgenda"
                                  class="table table-hover compact cell-border nowrap stripe" id="agendaTable"
                                  style="cursor: pointer;">
                                  <thead>
                                      <tr>
                                          <th style="display:none;">Agenda Order</th>
                                          <th style="display:none;">ID</th>
                                          <th style="width:5%">Agenda Number</th>
                                          <th style="width:20%">Agenda Title</th>
                                          <th style="width:5%">Group Number</th>
                                          <th style="width:10%">Group Name</th>
                                          <th style="width:20%">Agenda Document</th>
                                          <th style="width:15%">Minute Document</th>
                                          <th style="width:15%">Attachment</th>
                                          <th style="width:10%">Action</th>
                                      </tr>
                                      <tr>
                                          <th style="display:none;">Agenda Order</th>
                                          <th style="display:none;">ID</th>
                                          <th style="width:5%">
                                              <button id="btnSaveInviteesInMeeting" type="button"
                                                  class="btn btn-sm btn-primary" (click)="agendaRenumber()"
                                                  [disabled]="meetingFreezeStatus">
                                                  <i class="fa fa-save"></i>&nbsp;Renumber</button>
                                          </th>
                                          <th style="width:20%"></th>
                                          <th style="width:5%">
                                              <button id="btnGroupSort" type="button"
                                                  class="btn btn-sm btn-primary" (click)="agendaGroupSort()"
                                                  [disabled]="meetingFreezeStatus">
                                                  <i class="fa fa-save"></i>&nbsp;Group Sort</button>
                                          </th>
                                          <th style="width:10%"></th>
                                          <th style="width:20%">
                                              <button id="btnUpdateAgenda" type="button"
                                                  class="btn btn-sm btn-primary"
                                                  [disabled]="meetingFreezeStatus || isAgendaUpdateBtnEnable"
                                                  (click)="updateAgendaFiles()">
                                                  <i class="fa fa-save"></i>&nbsp;Update Agenda Files </button>
                                          </th>
                                          <th style="width:15%"></th>
                                          <th style="width:15%"></th>
                                          <th style="width:10%"></th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr *ngFor="let agenda of agendaArray; let count=index">
  
                                          <td style="display:none;">{{agenda.Agendaorder}}</td>
                                          <td style="display:none;">{{agenda._id}}</td>
  
                                          <td tabindex="1" class="reOrderRow" style="width:5%">
                                              {{agenda.AgendaNumber}}
                                          </td>
  
                                          <td tabindex="1" class="reOrderRow" style="width:20%">
                                              {{agenda.AgendaTitle}}
                                          </td>
                                          <td tabindex="1" class="reOrderRow" style="width:5%">
                                              {{agenda.groupNumber}}
                                          </td>
  
                                          <td tabindex="1" class="reOrderRow" style="width:10%">
                                              {{agenda.groupName}}
                                          </td>
                                          <td style="width:20%">
                                              <label class="input-group">
                                                  <input data-toggle="tooltip" type="text"
                                                      [value]="agenda.AgendaGenerationDocument ? agenda.AgendaGenerationDocument.DocName : 'File Not Available'"
                                                      class="form-control" [disabled]="true">
  
                                                  <span
                                                      *ngIf="agenda.AgendaGenerationDocument && agenda.AgendaGenerationDocument.IsAvailable && agenda.AgendaGenerationDocument.DocName != 'File Not Available' && agenda.AgendaGenerationDocument.DocName != ''"
                                                      (click)="downloadAgendaDocs(agenda.AgendaGenerationDocument.DocumentManagementID, agenda._id, 'Agenda')"
                                                      class="input-group-addon default">
                                                      <i class="fa fa-download"></i>
                                                  </span>
                                                  <span class="input-group-addon warning"
                                                      (click)="initiateUploadAgendaDocs(agenda, 'Agenda')"
                                                      *ngIf="!meetingFreezeStatus">
                                                      <i class="fa fa-upload"></i>
                                                  </span>
  
                                              </label>
                                          </td>
                                          <td style="width:15%">
                                              <label class="input-group">
                                                  <input data-toggle="tooltip" type="text"
                                                      [value]="agenda.AgendaMinuteDocument ? agenda.AgendaMinuteDocument.DocName : 'File Not Available'"
                                                      class="form-control" [disabled]="true">
  
                                                  <span
                                                      *ngIf="agenda.AgendaMinuteDocument  && agenda.AgendaMinuteDocument.DocName != 'File Not Available' && agenda.AgendaMinuteDocument.DocName != ''"
                                                      (click)="downloadAgendaDocs(agenda.AgendaMinuteDocument.DocumentManagementID, agenda._id, 'Minute')"
                                                      class="input-group-addon default">
                                                      <i class="fa fa-download"></i>
                                                  </span>
                                                  <span class="input-group-addon warning"
                                                      (click)="initiateUploadAgendaDocs(agenda, 'Minutes')"
                                                      *ngIf="!meetingFreezeStatus">
                                                      <i class="fa fa-upload"></i>
                                                  </span>
  
                                              </label>
                                          </td>
  
                                          <td style="width:15%">
                                              <label class="input-group">
                                                  <input data-toggle="tooltip" type="text"
                                                      [value]="agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length > 0 ? agenda.AgendaGenerationPdf.length + ' Files': 'File Not Available'"
                                                      class="form-control" [disabled]="true">
  
                                                  <span class="input-group-addon warning"
                                                      (click)="initiateUploadAgendaPdf(agenda)"
                                                      *ngIf="!meetingFreezeStatus">
                                                      <i class="fa fa-upload"></i>
                                                  </span>
  
                                              </label>
                                          </td>
  
                                          <td tabindex="4" style="width:10%">
  
                                              <!--  Open / New -->
                                              <!-- style="width:70px"-->
                                              <button *ngIf="agenda.meetingID" type="button"
                                                  class="btn-sm btn btn-warning" data-toggle="modal"
                                                  (click)="editAgendaInAgenda(agenda._id)"
                                                  [disabled]="meetingFreezeStatus">
                                                  <span class="fa fa-pencil"></span>
                                              </button>
                                              <!-- Library -->
                                              <!-- style="width:70px"-->
                                              <button *ngIf="!agenda.meetingID" type="button"
                                                  class="btn-sm btn btn-warning" data-toggle="modal"
                                                  (click)="editAgendaLibraryInAgenda(agenda._id)"
                                                  [disabled]="meetingFreezeStatus">
                                                  <span class="fa fa-pencil"> </span>
                                              </button>
  
                                              <button type="button" class="btn-sm btn btn-danger"
                                                  (click)="agendaDeleteConFirmation(agenda)"
                                                  [disabled]="meetingFreezeStatus">
                                                  <span class="icmn-bin"></span>
                                              </button>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
  
              </section>
              <div class="modal-footer" [ngStyle]="{'opacity':loading === true ? 0.5 : 1}">
                  <button type="button" class="btn btn-sm btn-primary" (click)="generateConsolidatedFile()"
                      [disabled]="meetingFreezeStatus">
                      <i class="fa fa-save"></i>Generate Consolidated Docx</button>
                  <button id="test" type="button" class="btn btn-sm btn-primary"
                      (click)="generateConsolidatedPdf()" [disabled]="meetingFreezeStatus">
                      <i class="fa fa-save"></i>Generate Consolidated Pdf</button>
                  <button type="button" class="btn-sm btn btn-primary" (click)="UploadConsolidatedDocs()"
                      [disabled]="meetingFreezeStatus">
                      <i class="fa fa-save"></i>Upload Combined Agenda Word</button>
  
  
                  <button id="btnSaveInviteesInMeeting" type="button" class="btn btn-sm btn-primary"
                      (click)="agendaSaveOrder()" [disabled]="meetingFreezeStatus || disabledOnclick">
                      <i class="fa fa-save"></i>Save Order</button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="clickTransferToGem()"
                      style="display:none">
                      <i class="fa fa-save"></i>Transfer to GEM</button>
              </div>
          </div>
  
  
          <!-- Compliance Data -->
          <div class="tab-pane {{complianceActive}}" id="ComplianceTab" role="tabcard">
  
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">
                          Compliances
                      </span>
                      <span style="float: right">
                          <div class="btn-group" role="group" aria-label="Basic example">
                              <button type="button" class="btn btn-sm btn-primary" data-toggle="modal"
                                  data-target="#AddCompliancesDialog" (click)="addComplianceModalOpenEvent()"
                                  [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}"
                                  [disabled]="meetingFreezeStatus">
                                  <i class="fa fa-plus"></i>Add Compliances</button>
                          </div>
                      </span>
                  </div>
  
                  <section class="card search-box">
                      <div class="card-header" data-toggle="collapse" data-target="#search-div">Modify Search
                          <span class="pull-right">
                              <i class="fa fa-filter" aria-hidden="true"></i>
                          </span>
                      </div>
                      <div class="card-block collapse" id="search-div">
                          <div class="row">
                              <div class="col-lg-12">
                                  <form>
                                      <div class="row">
                                          <div class="col-sm-5">
                                              <label>Agenda</label>
                                              <div class="input-group">
                                                  <select class=" form-control" [(ngModel)]="filterAgendaId"
                                                      [ngModelOptions]="{standalone:true}"
                                                      (ngModelChange)="getProcessByMeetingAgendaId(filterAgendaId)">
                                                      <option value=null [selected]="true">Select</option>
                                                      <option *ngFor="let agenda of agendaForFilter"
                                                          [value]="agenda._id">{{agenda.AgendaTitle}}</option>
                                                  </select>
                                              </div>
                                          </div>
                                          <div class="col-sm-5">
                                              <label>Process :</label>
                                              <div class="input-group">
                                                  <select id="drpmeeting" [(ngModel)]="filterProcessId"
                                                      class="form-control" [ngModelOptions]="{standalone:true}">
                                                      <option value=null [selected]="true">Select</option>
                                                      <option *ngFor="let process of processForFilter"
                                                          [ngValue]="process._id">
                                                          {{process.ProcessName}}</option>
                                                  </select>
                                              </div>
                                          </div>
  
  
                                          <div class="col-sm-2">
                                              <label>&nbsp;&nbsp;&nbsp;</label>
                                              <div class="input-group">
                                                  <!-- getMeetingByParam() -->
                                                  <button type="button" class="btn btn-sm btn-primary mb-2"
                                                      (click)=" searchCompliance();">
                                                      <i class="fa fa-search"></i>&nbsp;Search</button>
                                                  &nbsp;&nbsp;&nbsp;
                                                  <button type="button" class="btn btn-sm btn-default mb-2"
                                                      (click)="clearComplianceFilter()">
                                                      <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                                              </div>
                                          </div>
                                      </div>
                                  </form>
                              </div>
                          </div>
                      </div>
                  </section>
  
                  <div class="card-block datatable-card-block">
                      <div class="col-lg-12">
                          <div class="table-responsive">
                              <table datatable [dtOptions]="dtOptionsOfAddingCompliance"
                                  [dtTrigger]="dtTriggerAddingCompliance"
                                  class="table table-hover compact cell-border nowrap stripe" id="addedtaskTable"
                                  style="cursor: pointer;">
                                  <thead>
                                      <tr>
  
                                          <th class="activatedTask-list-column">Task Name </th>
                                          <th class="activatedTask-list-column">Task Particulars</th>
                                          <th class="activatedTask-list-column">Tag Name</th>
                                          <th class="activatedTask-list-column">Assigned To</th>
                                          <!-- <th class="activatedTask-list-column">Responsible User</th> -->
                                          <th>Due Date</th>
                                          <th>Completed Date</th>
                                          <th>Task Status </th>
                                          <th class="activatedTask-list-column">
                                              <span
                                                  [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}">Action</span>
                                          </th>
                                      </tr>
                                  </thead>
  
                                  <tbody>
                                      <tr *ngFor="let companytask of activatedTaskList; let count=index"
                                          [ngClass]="{'inActiveCompanyTasks':companytask.TriggerID == '5eb94ca3ffaa93751ec4f387' && companytask.DueDate==null}">
  
                                          <td class="activatedTask-list-column">{{companytask.TaskName }} </td>
                                          <td class="activatedTask-list-column">
                                              <span
                                                  *ngIf="companytask.ActivatedTaskParticularId!= undefined && companytask.ActivatedTaskParticularId!= null; else noTaskParticulars">{{companytask.ActivatedTaskParticularId.TaskParticulars }}
                                              </span>
                                              <ng-template #noTaskParticulars></ng-template>
                                          </td>
                                          <td class="activatedTask-list-column">{{companytask.GroupID.GroupName }}
                                          </td>
                                          <td class="activatedTask-list-column">{{companytask.AssignedName}} </td>
  
                                          <td>
                                              <span *ngIf="companytask.DueDate && companytask.DueDate!=null">
                                                  <span
                                                      style="display: none">{{companytask.DueDate | date : "yMMdd"}}
                                                  </span>{{companytask.DueDate | date : "dd-MM-y" }}</span>
                                              <span
                                                  *ngIf="companytask.TriggerID != '5eb94ca3ffaa93751ec4f387' && companytask.DueDate==null">-</span>
                                              <span
                                                  *ngIf="companytask.TriggerID == '5eb94ca3ffaa93751ec4f387' && companytask.DueDate==null">Please
                                                  select
                                                  specific date</span>
  
                                          </td>
  
                                          <td>
                                              <span
                                                  *ngIf="companytask.CompletedDate && companytask.CompletedDate!=null;else notcompDate">
                                                  <span
                                                      style="display: none">{{companytask.CompletedDate | date : "yMMdd"}}</span>{{companytask.CompletedDate
                                                  | date : "dd-MM-y" }}</span>
                                              <ng-template #notcompDate></ng-template>
                                          </td>
  
                                          <td>
                                              {{getTaskStatus(companytask.DueDate,companytask.CompletedDate,companytask.TaskStatus)}}
                                          </td>
                                          <td class="activated-list-action">
                                              <button type="button" class="btn-sm btn btn-warning"
                                                  (click)="EditTask(companytask._id)"
                                                  [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}"
                                                  [disabled]="meetingFreezeStatus">
                                                  <span class="fa fa-pencil"></span>
                                              </button>&nbsp;&nbsp;&nbsp;
  
                                              <button type="button" class="btn-sm btn btn-danger"
                                                  (click)="confirmationForDeleteCompliance(companytask)"
                                                  [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}"
                                                  [disabled]="meetingFreezeStatus">
                                                  <span class="icmn-bin"></span>
                                              </button>
  
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </section>
          </div>
  
  
  
          <!-- AgendaStoreModal -->
          <div class="modal fade modal-size-large" id="agendaStoreDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel">
                              <i class="fa fa-plus"></i>&nbsp;Agenda</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body modal-body-noBodyPadding">
                          <div class="card-block datatable-card-block">
                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="margin-bottom-50">
                                          <div class="table-responsive">
                                              <table datatable [dtOptions]="dtOptionsOfAgendaStore"
                                                  [dtTrigger]="dtTriggerAgendaStore"
                                                  class="table table-hover compact cell-border nowrap stripe"
                                                  id="agendaStoreTable" style="cursor: pointer;">
                                                  <thead>
                                                      <tr>
                                                          <th style="display: none;">Agenda Id</th>
                                                          <th>
                                                              <div class="md-checkbox">
                                                                  <input id="selectAgendaStorecheckboxall"
                                                                      class="md-checkbox"
                                                                      [ngModelOptions]="{standalone: true}"
                                                                      type="checkbox"
                                                                      [(ngModel)]="selectedAllAgendaStore"
                                                                      (change)="checkAllAgendaStore($event);" />
                                                                  <label
                                                                      for="selectAgendaStorecheckboxall">&nbsp;</label>
                                                              </div>
                                                          </th>
  
                                                          <th>Agenda Number</th>
                                                          <th>Agenda Title</th>
                                                          <th>Group Number</th>
                                                          <th>Group Name</th>
                                                          <th>Meeting Type</th>
                                                          <th>Category Name</th>
  
                                                      </tr>
                                                  </thead>
                                                  <tbody>
                                                      <ng-container
                                                          *ngFor="let agenda of agendaData;let count=index">
                                                          <tr>
                                                              <td style="display: none;" tabindex="1">
                                                                  {{agenda._id}}
                                                              </td>
                                                              <td>
                                                                  <div class="md-checkbox">
                                                                      <input
                                                                          id="selectAgendaStorecheckbox{{count +1 }}"
                                                                          type="checkbox"
                                                                          [(ngModel)]="agenda.selectAgenda"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          (change)="agendaFromStoreSelected($event)">
                                                                      <label
                                                                          for="selectAgendaStorecheckbox{{count +1 }}">&nbsp;</label>
                                                                  </div>
                                                              </td>
                                                              <td tabindex="1">{{agenda.AgendaNumber}}</td>
                                                              <td tabindex="1">{{agenda.AgendaTitle}}</td>
                                                              <td tabindex="1">{{agenda.groupNumber}}</td>
                                                              <td tabindex="1">{{agenda.groupName}}</td>
                                                              <td tabindex="1">{{agenda.MeetingType}}</td>
                                                              <td tabindex="1">{{agenda.CategoryName}}</td>
  

                                                          </tr>
                                                      </ng-container>
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button id="btnsaveAgenda" type="button" (click)="addAgendaFromAgenaStore()"
                              class="btn-sm btn btn-primary" [disabled]="!IsSelectedAgenda || disabledOnclick">
                              <i class="fa fa-save"></i>&nbsp;Add Agenda
                          </button>
                          <button type="button" class="btn btn-sm" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;Close
                          </button>
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- AgendaCompliance POPUP LIST -->
          <div class="modal fade modal-size-large" id="agendasCompliancePopUp" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="agendasCompliancePopUpLabel">
                              <i class="fa fa-list"></i> Compliances</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="card-block datatable-card-block">
                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="margin-bottom-50">
                                          <div class="table-responsive">
                                              <table datatable [dtOptions]="dtOptionsOfAgendaCompliancePopUp"
                                                  [dtTrigger]="dtTriggerAgendaCompliancePopUp"
                                                  class="table table-hover compact cell-border nowrap stripe"
                                                  id="agendaCompliancePopUpTable" style="cursor: pointer;">
                                                  <thead>
                                                      <tr>
                                                          <th>Task Name</th>
                                                          <th>Task Description</th>
                                                          <th>Global/Company Specific</th>
                                                          <th>Tag </th>
                                                      </tr>
                                                  </thead>
  
                                                  <tbody>
  
                                                      <tr *ngFor="let agendaCompliance of agendaCompliances">
                                                          <td>{{agendaCompliance.TaskName}}</td>
                                                          <td>{{agendaCompliance.TaskDescription}}</td>
                                                          <td>
                                                              <span
                                                                  *ngIf="agendaCompliance.IsGlobal">Global</span>
                                                              <span *ngIf="!agendaCompliance.IsGlobal">Company
                                                                  Specific
                                                              </span>
                                                          </td>
                                                          <td>{{agendaCompliance.GroupName}}</td>
                                                      </tr>
                                                  </tbody>
                                              </table>
  
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
  
                      <div class="modal-footer">
                          <button type="button" class="btn btn-sm" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;Close
                          </button>
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- AddCompliancesModal -->
          <div class="modal fade modal-size-large" id="AddCompliancesDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" data-keyboard="false" data-backdrop="static"
              aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
  
                  <div class="modal-content">
  
                      <div class="modal-header">
                          <h5 class="modal-title" id="taskLabel">
                              <i class="fa fa-plus"></i>&nbsp; Add Compliances</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body modal-body-noBodyPadding">
  
                          <section class="card search-box ">
                              <div class="card-block">
  
                                  <div class="row">
                                      <div class="col-md-4">
                                          <div class="input-group">
                                              <div class="md-radio md-radio-inline">
                                                  <input id="IsPredefinedYes" type="radio"
                                                      style="position:absolute"
                                                      [ngModelOptions]="{standalone: true}"
                                                      name="TaskuserdefinedorPredefined"
                                                      [(ngModel)]="SearchtaskUserdefinedorPredefinedModel"
                                                      value='true' class="form-check-input">
                                                  <label for="IsPredefinedYes">Pre-Defined</label>
                                              </div>
                                              <div class="md-radio md-radio-inline">
                                                  <input id="IsPredefinedNo" type="radio"
                                                      style="position:absolute"
                                                      [ngModelOptions]="{standalone: true}"
                                                      name=" TaskuserdefinedorPredefined"
                                                      [(ngModel)]="SearchtaskUserdefinedorPredefinedModel"
                                                      value='false' class="form-check-input">
                                                  <label for="IsPredefinedNo">User Defined</label>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="col-md-2">
                                          <label> Tag</label>
                                      </div>
                                      <div class="col-md-3">
  
                                          <div class="form-group">
                                              <select id="groupdropdown" class="form-control select"
                                                  (change)="getSelectedGroupID($event)"
                                                  [(ngModel)]="searchByGroupID">
                                                  <option value="">Select</option>
                                                  <option *ngFor="let group of groupTypes" value={{group._id}}>
                                                      {{group.GroupName}}
                                                  </option>
                                              </select>
                                          </div>
                                      </div>
                                      <div class="col-md-3">
                                          <div class="md-radio md-radio-inline">
                                              <input id="IsEventBased" type="radio" style="position:absolute"
                                                  name="TaskEventbasedorPeriodic"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [(ngModel)]="SearchtaskEventbasedorPeriodicModel"
                                                  [disabled]=true value='1' class="form-check-input">
                                              <label for="IsEventBased">Event Based</label>
                                          </div>
                                          <div class="md-radio md-radio-inline">
                                              <input id="IsPeriodic" type="radio" style="position:absolute"
                                                  name=" TaskEventbasedorPeriodic"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [(ngModel)]="SearchtaskEventbasedorPeriodicModel"
                                                  [disabled]=true value='2' class="form-check-input">
                                              <label for="IsPeriodic">Periodic</label>
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="row text-right">
                                      <div class="col-md-12">
                                          <button type="button" (click)="showTasksBySearchData()"
                                              class="btn btn-sm btn-primary" title="search">
                                              <i class="fa fa-search"></i>&nbsp;Search
                                          </button>
                                          <button type="button" class="btn btn-sm btn-default" title="refresh"
                                              (click)="showAllTasks()">
                                              <i class="fa fa-refresh"></i>&nbsp;Clear
                                          </button>
                                      </div>
                                  </div>
  
                              </div>
                          </section>
  
                          <div class="card-block datatable-card-block">
                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="margin-bottom-50">
                                          <div class="table-responsive">
                                              <table datatable [dtOptions]="dtOptionsOfCompliance"
                                                  [dtTrigger]="dtTriggerCompliance"
                                                  class="table table-hover compact cell-border nowrap stripe"
                                                  id="companytaskTable"
                                                  style="cursor: pointer; width: max-content">
                                                  <thead>
                                                      <tr>
                                                          <th style="display: none">Task Id </th>
                                                          <th>
                                                              <div class="md-checkbox">
                                                                  <input id="selectCompliancecheckboxall"
                                                                      class="md-checkbox" type="checkbox"
                                                                      [ngModelOptions]="{standalone: true}"
                                                                      [(ngModel)]="selectedAll"
                                                                      (change)="checkAllCompliances($event);" />
                                                                  <label
                                                                      for="selectCompliancecheckboxall">&nbsp;</label>
                                                              </div>
                                                          </th>
                                                          <th>Task Name </th>
                                                          <th>Task Description </th>
                                                          <th>Global/Company Specific </th>
                                                          <th>Tag</th>
                                                      </tr>
                                                  </thead>
                                                  <tbody>
                                                      <tr
                                                          *ngFor="let companytask of companytasklist; let count=index">
                                                          <td tabindex="1" style="display: none">
                                                              {{companytask.ID }}
                                                          </td>
                                                          <td>
                                                              <div class="md-checkbox">
                                                                  <input id="selectcheckbox{{count +1 }}"
                                                                      type="checkbox"
                                                                      [ngModelOptions]="{standalone: true}"
                                                                      [(ngModel)]="companytask.SelectedTask"
                                                                      (change)="checkselectedCompliance($event);">
                                                                  <label
                                                                      for="selectcheckbox{{count +1 }}">&nbsp;</label>
                                                              </div>
                                                          </td>
                                                          <td tabindex="1">{{companytask.TaskName }}</td>
                                                          <td tabindex="2">{{companytask.TaskDescription }}</td>
                                                          <td tabindex="3">
                                                              <span *ngIf="companytask.IsGlobal">Global</span>
                                                              <span *ngIf="!companytask.IsGlobal">Company Specific
                                                              </span>
                                                          </td>
                                                          <td tabindex="4">{{companytask.GroupName }}</td>
                                                      </tr>
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
  
                      <div class="modal-footer">
                          <button id="btnAddtask" [disabled]="disableAddTaskPopupButton || disabledOnclick"
                              type="button" class="btn-sm btn btn-primary" (click)="addSelectedCompliance()">
                              <i class="fa fa-check"></i>&nbsp;Add Selected Task</button>
                          <button type="button" class="btn btn-sm" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;Cancel</button>
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- Directors Data -->
          <div class="tab-pane {{directorActive}}" id="Directors" role="tabcard">
  
  
  
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">
                          <!-- Directors -->
                          {{directorTabName}}
                      </span>
                  </div>
                  <div class="card-block datatable-card-block">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="margin-bottom-50">
                                  <div class="table-responsive">
                                      <table datatable [dtOptions]="dtOptionsOfDirector"
                                          [dtTrigger]="dtTriggerDirector"
                                          class="table table-hover compact cell-border nowrap stripe"
                                          id="directorTable" style="cursor: pointer;">
                                          <thead>
                                              <tr>
                                                  <th>Name</th>
                                                  <th>Designation</th>
                                                  <th>Date of Appointment</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr *ngFor="let dirVar of Directors_Members_merged; let count = index ">
                                                  <td tabindex="1">
                                                      {{dirVar.DirectorName ? dirVar.DirectorName : dirVar.MemberName}}
                                                  </td>
                                                  <td tabindex="1">
                                                      <span *ngIf='dirVar.Designation==""'>NA</span>
                                                      <span
                                                          *ngIf='dirVar.Designation!==""'>{{dirVar.Designation}}</span>
                                                  </td>
                                                  <td tabindex="1">
                                                      <span *ngIf='dirVar.AppointmentDate==null'>NA</span>
                                                      <span *ngIf='dirVar.AppointmentDate!==""'>
                                                          {{dirVar.AppointmentDate | date : "dd-MM-y"}}</span>
                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>
          </div>
  
          <!-- ADD Director Form Modal -->
          <div class="modal fade modal-size-large" id="directorDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <form>
                          <div class="modal-header">
                              <h5 class="modal-title" id="myModalLabel">Director Details :
                              </h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <i class="fa fa-times"></i>
                              </button>
                          </div>
  
                          <div class="modal-body">
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">DIN
                                          <span _ngcontent-c2="" style="color: red;" class="span_margin">*</span>
                                      </label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <select class="form-control" *ngIf="updatedirectorButtonFlag"
                                              (change)="getDirectorDetails($event)"
                                              (selected)="directorObjectDinToBindWhileUpdating">
                                              <option *ngFor="let DinData of directorData" [value]="DinData.Din"
                                                  selected="directorObjectDinToBindWhileUpdating">
                                                  {{DinData.FirstName + " " + DinData.LastName}}
                                              </option>
                                          </select>
                                          <select class="form-control" *ngIf="!updatedirectorButtonFlag"
                                              (change)="getDirectorDetails($event)">
                                              <option value='' [selected]="true">Select</option>
                                              <option *ngFor="let DinData of directorData" [value]="DinData.Din">
                                                  {{DinData.FirstName + " " + DinData.LastName}}
                                              </option>
                                          </select>
                                          <div *ngIf="directorForm.controls['MemberName'].hasError('required') && directorForm.controls['MemberName'].touched"
                                              class="form-control-error-custom">
                                              Please select Din
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Director Name</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input type="hidden" [formControl]="directorForm.controls['DirectorID']"
                                              class="form-control">
                                          <input [formControl]="directorForm.controls['MemberName']"
                                              class="form-control" readonly>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Designation</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="directorForm.controls['Designation']"
                                              class="form-control" readonly>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Category</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="directorForm.controls['Category']"
                                              class="form-control" readonly>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Executive / Non-Executive</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="directorForm.controls['IsExecutive']"
                                              class="form-control" readonly>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Appointment Date</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <div class="input-group" (click)="$event.stopPropagation()"
                                              (document:click)="ap.close();">
                                              <input class="form-control"
                                                  [formControl]="directorForm.controls['AppointmentDate']"
                                                  style="padding:6px;" placeholder="dd-mm-yyyy"
                                                  name="AppointmentDate" ngbDatepicker #ap="ngbDatepicker"
                                                  (click)="ap.toggle();cs.close();" required="required">
                                              <button class="input-group-addon" (click)="ap.toggle();cs.close();"
                                                  type="button">
                                                  <span class="fa fa-calendar"
                                                      style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                              </button>
                                          </div>
                                          <div *ngIf="directorForm.controls['AppointmentDate'].hasError('required') && directorForm.controls['AppointmentDate'].touched"
                                              class="form-control-error-custom">
                                              Please select Appointment Date
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Tenure</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="directorForm.controls['Tenure']"
                                              class="form-control">
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Cessation Date</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <div class="input-group" (click)="$event.stopPropagation()"
                                              (document:click)="cs.close();">
                                              <input class="form-control"
                                                  [formControl]="directorForm.controls['CessationDate']"
                                                  style="padding:6px;" placeholder="dd-mm-yyyy"
                                                  name="CessationDate" ngbDatepicker #cs="ngbDatepicker"
                                                  (click)="cs.toggle();ap.close();">
  
                                              <button class="input-group-addon" (click)="cs.toggle(); ap.close();"
                                                  type="button">
                                                  <span class="fa fa-calendar"
                                                      style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Cessation Reason</label>
                                  </div>
                                  <div class="col-md-4">
                                      <input [formControl]="directorForm.controls['CessationReason']"
                                          class="form-control">
                                  </div>
                              </div>
  
                          </div>
  
                          <div class="modal-footer">
                              <button id="btnUpdateDirectorRow" *ngIf="updatedirectorButtonFlag" type="button"
                                  class="btn-sm btn btn-primary" [disabled]="!directorForm.valid"
                                  (click)="updateDirector()">
                                  <i class="fa fa-save"></i>&nbsp;Update</button>
  
                              <button id="btnaddDirectorRow" *ngIf="!updatedirectorButtonFlag" type="submit"
                                  class="btn-sm btn btn-primary" [disabled]="!directorForm.valid"
                                  (click)="addDirectorIntoTableCheckList()">
                                  <i class="fa fa-save"></i>&nbsp;Save</button>
                              <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                  <i class="fa fa-times"></i>&nbsp;Close</button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
  
          <!-- Invitees Data -->
          <div class="tab-pane {{invitteeActive}}" id="Invitees" role="tabcard">
  
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">
                          Invitees
                          <div class="pull-right">
  
                          </div>
  
                          <span style="float: right">
                              <div class="btn-group" role="group" aria-label="Basic example">
                                  <button type="button" *ngIf="environmentSettings.PSS"
                                      class="btn btn-sm btn-primary ml-2" data-toggle="modal"
                                      data-target="#InviteeDialog" (click)="addInviteeModal()"
                                      [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}"
                                      [disabled]="meetingFreezeStatus">
                                      <i class="fa fa-plus"></i>Add New Invitee</button>
  
                                  <button type="button" *ngIf="!environmentSettings.PSS"
                                      class="btn btn-sm btn-primary" (click)="getMembersFromGovevaForInvitee()"
                                      data-toggle="modal" data-target="#existingInviteeDialog"
                                      [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}"
                                      [disabled]="meetingFreezeStatus">
                                      <i class="fa fa-plus"></i> Choose Existing Invitee</button>
  
                              </div>
                          </span>
                      </span>
                  </div>
  
                  <div class="card-block datatable-card-block">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="margin-bottom-50">
                                  <div class="table-responsive">
                                      <table datatable [dtOptions]="dtOptionsOfInvitee"
                                          [dtTrigger]="dtTriggerInvitee"
                                          class="table table-hover compact cell-border nowrap stripe"
                                          id="inviteeTable" style="cursor: pointer;">
                                          <thead>
                                              <tr>
                                                  <th style="width: 140px;">Deselect From Meeting</th>
                                                  <th>Name</th>
                                                  <th>Designation</th>
                                                  <th>In Attendance</th>
                                                  <th>Action</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr *ngFor="let invVar of Invitees; let count = index ">
                                                  <td style="width: 140px;">
                                                      <div class="md-checkbox">
                                                          <input id="selectInvitee{{count + 1 }}" type="checkbox"
                                                              [(ngModel)]="invVar.Selected"
                                                              [ngModelOptions]="{standalone: true}"
                                                              (change)="checkIfAllInviteeSelected(invVar._id);">
                                                          <label for="selectInvitee{{count +1 }}">&nbsp;</label>
                                                      </div>
                                                  </td>
                                                  <td tabindex="1">{{invVar.InviteeName}}</td>
                                                  <td tabindex="1">{{invVar.Designation}}</td>
                                                  <td tabindex="1">
                                                      <span
                                                          *ngIf="invVar.InAttendance == 'Yes'">In-Attendance</span>
                                                      <span
                                                          *ngIf="invVar.InAttendance != 'Yes' && invVar.InAttendance != 'No' ">{{invVar.InAttendance}}</span>
                                                      <span *ngIf="invVar.InAttendance == 'No'">Permanent Invitee
                                                      </span>
                                                  </td>
                                                  <td style='white-space: nowrap'>
  
                                                      <button type="button"
                                                          *ngIf="invVar.UserGovevaId==null || invVar.UserGovevaId=='null'"
                                                          class="btn-sm btn btn-warning"
                                                          (click)="updateInviteeModalOpen(invVar)"
                                                          [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}"
                                                          [disabled]="meetingFreezeStatus">
                                                          <span class="fa fa-pencil"></span>
                                                      </button>&nbsp;&nbsp;&nbsp;
                                                      <button type="button" class="btn-sm btn btn-danger"
                                                          *ngIf="MeetingTypeName == 'Board' || (invVar.InAttendance == 'Special Invitee' && MeetingTypeName != 'Board')"
                                                          (click)="deleteInviteeConfirmation(invVar)"
                                                          [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}"
                                                          [disabled]="meetingFreezeStatus">
                                                          <span class="icmn-bin"></span>
                                                      </button>
  
  
                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
  
              </section>
  
              <!-- <div class="modal-footer">
                          <button id="btnSaveInviteesInMeeting" *ngIf="Invitees" type="button" class="btn btn-sm btn-primary" (click)="updateSelectedInvitees(Invitees)">
                              <i class="fa fa-save"></i>Update Selected Invitee</button>
                      </div> -->
              <div class="modal-footer">
                  <button id="btnSaveInviteesInMeeting" type="button" class="btn btn-sm btn-primary"
                      (click)="updateSelectedInvitees(Invitees)"
                      [disabled]="meetingFreezeStatus || disabledOnclick">
                      <i class="fa fa-save"></i>Update Selected Invitee</button>
              </div>
          </div>
  
          <div class="modal fade" id="deleteInvitteeData" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="">
                              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="row">
                              <div class="col-sm-12">
                                  Are you sure you want to Delete this Invitee From Meeting also from Committee
                                  details?
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button type="button" class="btn btn-sm btn-danger" (click)="deleteInvitee()"
                              data-dismiss="modal">
                              <i class="fa fa-check"></i>&nbsp;Yes</button>
                          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;No</button>
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- ADD Invitees Form Modal -->
          <div class="modal fade modal-size-large" id="InviteeDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <form>
                          <div class="modal-header">
                              <h5 class="modal-title" id="myModalLabel">Invitee Details :
                              </h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <i class="fa fa-times"></i>
                              </button>
                          </div>
                          <div class="modal-body">
                              <div class="row">
                                  <div class="col-md-12">
                                      <div *ngIf="hideUpdateButtonOfInvitee"
                                          class="warning-note badge badge-warning" style="text-align: center">
                                          Note: You can update this invitee from committee only, As it is not the
                                          special invitee.
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Invitee Name</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['InviteeName']"
                                              class="form-control">
                                          <div *ngIf="inviteeForm.controls['InviteeName'].hasError('required') && inviteeForm.controls['InviteeName'].touched"
                                              class="form-control-error-custom">
                                              Invitee Name is required.
                                          </div>
                                          <div *ngIf="inviteeForm.controls['InviteeName'].hasError('pattern') && inviteeForm.controls['InviteeName'].touched"
                                              class="form-control-error-custom">
                                              Invitee Name is invalid.
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Designation</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['Designation']"
                                              class="form-control" (keydown)="onlyAlphabates($event)">
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Address</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['Address']"
                                              class="form-control">
                                      </div>
                                  </div>
  
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">City</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['City']" class="form-control"
                                              (keydown)="onlyAlphabates($event)">
                                          <div *ngIf="inviteeForm.controls['City'].hasError('pattern') && inviteeForm.controls['City'].touched"
                                              class="form-control-error-custom">
                                              City is invalid.
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">State</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <div class="input-group">
                                              <input [formControl]="inviteeForm.controls['State']"
                                                  class="form-control" (keydown)="onlyAlphabates($event)">
                                          </div>
                                          <div *ngIf="inviteeForm.controls['State'].hasError('pattern') && inviteeForm.controls['State'].touched"
                                              class="form-control-error-custom">
                                              State is invalid.
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Tel(O)</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['TelO']" class="form-control"
                                              pattern="^\d{4}\d{3}\d{4}$">
                                          <div *ngIf="inviteeForm.controls['TelO'].hasError('pattern') && inviteeForm.controls['TelO'].touched"
                                              class="form-control-error-custom">
                                              Telephone number is invalid.
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Tel(R)</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['TelR']" class="form-control"
                                              pattern="^\d{4}\d{3}\d{4}$">
                                          <div *ngIf="inviteeForm.controls['TelR'].hasError('pattern') && inviteeForm.controls['TelR'].touched"
                                              class="form-control-error-custom">
                                              Telephone number is invalid.
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Through VC</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <!-- Radio fields -->
                                          <div class="md-radio md-radio-inline">
                                              <input id="ThroughVCY" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['ThroughVC']"
                                                  name="ThroughVC" value="Yes" class="form-check-input">
                                              <label for="ThroughVCY">Yes</label>
                                          </div>
                                          <div class="md-radio md-radio-inline">
                                              <input id="ThroughVCN" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['ThroughVC']"
                                                  name="ThroughVC" value="No" class="form-check-input">
                                              <label for="ThroughVCN">No</label>
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Fax No</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['FaxNo']"
                                              class="form-control" pattern="^\+?[0-9]{7,}$">
                                          <div *ngIf="inviteeForm.controls['FaxNo'].hasError('pattern') && inviteeForm.controls['FaxNo'].touched"
                                              class="form-control-error-custom">
                                              Fax Number is not valid.
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Mobile No</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <input [formControl]="inviteeForm.controls['MobileNo']" class="form-control"
                                          pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                                      <div *ngIf="inviteeForm.controls['MobileNo'].hasError('pattern') && inviteeForm.controls['MobileNo'].touched"
                                          class="form-control-error-custom">
                                          Mobile Number is not valid.
                                      </div>
                                      <div *ngIf="inviteeForm.controls['MobileNo'].hasError('required') && inviteeForm.controls['MobileNo'].touched"
                                          class="form-control-error-custom">
                                          Mobile Number is required.
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Email Id</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input type="email" [formControl]="inviteeForm.controls['EmailId']"
                                              class="form-control"
                                              pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                                          <div *ngIf="inviteeForm.controls['EmailId'].hasError('required') && inviteeForm.controls['EmailId'].touched"
                                              class="form-control-error-custom">
                                              Email Id is required.
                                          </div>
                                          <div *ngIf="inviteeForm.controls['EmailId'].hasError('pattern') && inviteeForm.controls['EmailId'].touched && !inviteeForm.controls['EmailId'].hasError('required')"
                                              class="form-control-error-custom">
                                              Email Id is incorrect.
                                          </div>
                                          <div *ngIf="checkEmailIdExistInInvitee"
                                              class="form-control-error-custom">
                                              Email Id is already exist.
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Invitees attendance
                                          <span style="color: red;" class="span_margin">*</span>
                                      </label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <!-- Radio fields -->
                                          <div class="md-radio md-radio-inline">
                                              <input id="inAttandanceY" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['InAttendance']"
                                                  name="inAttendance" value="Yes" class="form-check-input">
                                              <label for="inAttandanceY">In-Attendance</label>
                                          </div>
                                          <div class="md-radio md-radio-inline">
                                              <input id="inAttandanceN" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['InAttendance']"
                                                  name="inAttendance" value="No" class="form-check-input">
                                              <label for="inAttandanceN">Permanent Invitee</label>
                                          </div>
                                          <div class="md-radio md-radio-inline">
                                              <input id="inAttandanceSpecial" type="radio"
                                                  style="position:absolute"
                                                  [formControl]="inviteeForm.controls['InAttendance']"
                                                  name="inAttendance" value="Special Invitee"
                                                  class="form-check-input">
                                              <label for="inAttandanceSpecial">Special Invitee</label>
                                          </div>
                                      </div>
                                  </div>
  
                              </div>
  
  
  
                          </div>
  
                          <div class="modal-footer">
                              <div *ngIf="alreadyExist" class="form-control-error-custom text_center">This User is
                                  already exists in Members Details</div>
                              <button id="btnUpdateMember" *ngIf="updateinviteeButtonFlag" type="button"
                                  class="btn-sm btn btn-primary"
                                  [disabled]="!inviteeForm.valid || hideUpdateButtonOfInvitee"
                                  (click)="updateInvitee()">
                                  <i class="fa fa-save"></i>&nbsp;Update</button>
                              <button id="btnaddInvitee" *ngIf="!updateinviteeButtonFlag" type="Submit"
                                  class="btn-sm btn btn-primary" [disabled]="!inviteeForm.valid"
                                  (click)="addInviteeIntoCheckList()">
                                  <i class="fa fa-save"></i>&nbsp;Save</button>
                              <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                  <i class="fa fa-times"></i>&nbsp;Close</button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
  
          <div class="modal fade modal-size-large" id="existingInviteeDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
  
                      <form>
                          <div class="modal-header">
                              <h5 class="modal-title" id="InviteeLabel">Invitee Details :
                              </h5>
  
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <i class="fa fa-times"></i>
                              </button>
                          </div>
  
                          <div class="modal-body">
  
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Select Invitee</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
  
                                          <select class="form-control" (change)="selectMemberFromInvittee($event)"
                                              [(ngModel)]="inviteeGovevaMemberSelectBox"
                                              [ngModelOptions]="{standalone: true}">
                                              <option value='null' [selected]="true">Select</option>
                                              <option *ngFor="let invittee of invitteeListFromGovevea"
                                                  [value]="invittee._id">
                                                  {{invittee.FullName ? invittee.FullName : invittee.Title +''+ invittee.FirstName + ' ' +invittee.LastName}}
                                              </option>
                                          </select>
                                      </div>
                                  </div>
                              </div>
  
                              <input type="hidden" name="govevaUserId"
                                  [formControl]="inviteeForm.controls['GovevaUserId']">
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Invitee Name</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['InviteeName']"
                                              class="form-control">
                                          <div *ngIf="inviteeForm.controls['InviteeName'].hasError('required') && inviteeForm.controls['InviteeName'].touched"
                                              class="form-control-error-custom">
                                              Invitee Name is required.
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Designation</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['Designation']"
                                              class="form-control">
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Address</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['Address']"
                                              class="form-control">
                                      </div>
                                  </div>
  
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">City</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['City']" class="form-control"
                                              (keydown)="onlyAlphabates($event)">
                                          <div *ngIf="inviteeForm.controls['City'].hasError('pattern') && inviteeForm.controls['City'].touched"
                                              class="form-control-error-custom">
                                              City is invalid.
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">State</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <div class="input-group">
                                              <input [formControl]="inviteeForm.controls['State']"
                                                  class="form-control">
                                          </div>
  
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Tel(O)</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['TelO']" class="form-control"
                                              pattern="^\d{4}\d{3}\d{4}$">
                                          <div *ngIf="inviteeForm.controls['TelO'].hasError('pattern') && inviteeForm.controls['TelO'].touched"
                                              class="form-control-error-custom">
                                              Telephone number is invalid.
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Tel(R)</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['TelR']" class="form-control"
                                              pattern="^\d{4}\d{3}\d{4}$">
                                          <div *ngIf="inviteeForm.controls['TelR'].hasError('pattern') && inviteeForm.controls['TelR'].touched"
                                              class="form-control-error-custom">
                                              Telephone number is invalid.
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Through VC</label>
                                  </div>
                                  <div class="col-md-4">
  
  
                                      <div class="form-group">
                                          <!-- Radio fields -->
                                          <div class="md-radio md-radio-inline">
                                              <input id="ThroughVCYExt" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['ThroughVC']"
                                                  name="ThroughVC" value="Yes" class="form-check-input">
                                              <label for="ThroughVCYExt">Yes</label>
                                          </div>
                                          <div class="md-radio md-radio-inline">
                                              <input id="ThroughVCNExt" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['ThroughVC']"
                                                  name="ThroughVC" value="No" class="form-check-input">
                                              <label for="ThroughVCNExt">No</label>
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Fax No</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="inviteeForm.controls['FaxNo']"
                                              class="form-control" pattern="^\+?[0-9]{7,}$">
                                          <div *ngIf="inviteeForm.controls['FaxNo'].hasError('pattern') && inviteeForm.controls['FaxNo'].touched"
                                              class="form-control-error-custom">
                                              Fax Number is not valid.
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Mobile No</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <input [formControl]="inviteeForm.controls['MobileNo']" class="form-control"
                                          pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                                      <div *ngIf="inviteeForm.controls['MobileNo'].hasError('pattern') && inviteeForm.controls['MobileNo'].touched"
                                          class="form-control-error-custom">
                                          Mobile Number is not valid.
                                      </div>
                                      <div *ngIf="inviteeForm.controls['MobileNo'].hasError('required') && inviteeForm.controls['MobileNo'].touched"
                                          class="form-control-error-custom">
                                          Mobile Number is required.
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Email Id</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input type="email" [formControl]="inviteeForm.controls['EmailId']"
                                              pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                              class="form-control">
                                          <div *ngIf="inviteeForm.controls['EmailId'].hasError('required') && inviteeForm.controls['EmailId'].touched"
                                              class="form-control-error-custom">
                                              Email Id is required.
                                          </div>
                                          <div *ngIf="inviteeForm.controls['EmailId'].hasError('pattern') "
                                              class="form-control-error-custom">
                                              Email Id is incorrect.
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Invitees attendance
                                          <span style="color: red;" class="span_margin">*</span>
                                      </label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <!-- Radio fields -->
                                          <div class="md-radio md-radio-inline">
                                              <input id="inAttandanceYExt" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['InAttendance']"
                                                  name="inAttendance" value="Yes" class="form-check-input">
                                              <label for="inAttandanceYExt">In-Attendance</label>
                                          </div>
                                          <div class="md-radio md-radio-inline">
                                              <input id="inAttandanceNExt" type="radio" style="position:absolute"
                                                  [formControl]="inviteeForm.controls['InAttendance']"
                                                  name="inAttendance" value="No" class="form-check-input">
                                              <label for="inAttandanceNExt">Permanent Invitee</label>
                                          </div>
                                          <div class="md-radio md-radio-inline">
                                              <input id="inAttandanceSpecialExist" type="radio"
                                                  style="position:absolute"
                                                  [formControl]="inviteeForm.controls['InAttendance']"
                                                  name="inAttendance" value="Special Invitee"
                                                  class="form-check-input">
                                              <label for="inAttandanceSpecialExist">Special Invitee</label>
                                          </div>
                                      </div>
                                  </div>
  
                              </div>
                          </div>
                          <div class="modal-footer">
                              <button id="btnUpdateInviteeRow" type="button" class="btn-sm btn btn-primary"
                                  [disabled]="!inviteeForm.valid || disabledOnclick" (click)="updateInvitee()"
                                  style="display:none">
                                  <i class="fa fa-save"></i>&nbsp;Update</button>
                              <button id="btnaddInviteeRow" type="submit" class="btn-sm btn btn-primary"
                                  [disabled]="!inviteeForm.valid || !isAddExistingInvitteeValid || disabledOnclick"
                                  (click)="saveInviteeForGoveva()">
                                  <i class="fa fa-save"></i>&nbsp;Save</button>
                              <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                  <i class="fa fa-times"></i>&nbsp;Close</button>
                          </div>
                      </form>
  
                  </div>
              </div>
          </div>
  
          <!-- Members Data -->
          <div class="tab-pane  {{memberActive}}" id="Members" role="tabcard">
  
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">
                          Members
                          <!-- <div class="pull-right">
                                      <button type="button" class="btn btn-sm btn-primary ml-2" data-toggle="modal" data-target="#MemberDialog" (click)="addMemberModal()">
                                          <i class="fa fa-plus"></i>Add Member</button>
                                  </div> -->
                      </span>
                  </div>
  
                  <!-- <div class="col-lg-12">
                                          <div class="d-flex justify-content-between bd-highlight mb-2">
                                              <div class="p-2 bd-highlight">
                                                  <h5 class="text-black">Members</h5>
                                              </div>
                                              <div class="p-2 bd-highlight">
                                                  <button type="button" class="btn btn-sm btn-primary ml-2" data-toggle="modal" data-target="#MemberDialog">
                                                      <i class="fa fa-plus"></i>Add Member</button>
                                              </div>
                                          </div>
                                      </div> -->
                  <div class="card-block datatable-card-block">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="margin-bottom-50">
                                  <div class="table-responsive">
                                      <table datatable [dtOptions]="dtOptionsOfMember"
                                          [dtTrigger]="dtTriggerMember"
                                          class="table table-hover compact cell-border nowrap stripe"
                                          id="memberTable" style="cursor: pointer;">
                                          <thead>
                                              <tr>
                                                  <th>Member Name</th>
                                                  <th *ngIf="environmentSettings.PSS">Chairman</th>
                                                  <!-- <th>Designation</th> -->
                                                  <th>Mobile No</th>
                                                  <th>Email Id</th>
  
                                                  <!-- <th>Action</th> -->
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr *ngFor="let memVar of Member; let count = index ">
                                                  <!-- <td>
                                                                  <div class="md-checkbox">
                                                                      <input id="selectMember{{count + 1 }}" type="checkbox" [(ngModel)]="memVar.selectedMember" [ngModelOptions]="{standalone: true}"
                                                                          (change)="checkIfAllMemberSelected();">
                                                                      <label for="selectMember{{count + 1 }}">&nbsp;</label>
                                                                  </div>
                                                              </td> -->
                                                  <td tabindex="1">{{memVar.MemberName}}</td>
                                                  <td tabindex="1" *ngIf="environmentSettings.PSS">
                                                      {{memVar.Chairman }}</td>
                                                  <td tabindex="1">{{memVar.MobileNo }}</td>
                                                  <td tabindex="1">{{memVar.EmailId }}</td>
  
  
                                                  <!-- <td tabindex="1">{{memVar.TypeOfUser }}</td> -->
                                                  <!--      <td style='white-space: nowrap'>
                                                              <button type="button" class="btn-sm btn btn-warning" (click)="updateMemberModalOpen(memVar)">
                                                                  <span class="fa fa-pencil"></span>
                                                              </button>&nbsp;&nbsp;&nbsp; -->
                                                  <!-- <button type="button" class="btn-sm btn btn-danger" (click)="deleteMember(memVar)">
                                                                  <span class="icmn-bin"></span>
                                                              </button>
                                                          </td> -->
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>
              <!-- <div class="modal-footer">
                                  <button id="btnSaveMembersInMeeting" type="button" class="btn btn-sm btn-primary" (click)="saveMembers()">
                                      <i class="fa fa-save"></i>Save</button>
                                  <button type="button" class="btn-sm btn btn-default">
                                      <i class="fa fa-refresh"></i>Clear</button>
                              </div> -->
          </div>
  
          <!-- ADD Members Form Modal -->
          <div class="modal fade modal-size-large" id="MemberDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <form>
                          <div class="modal-header">
                              <h5 class="modal-title" id="myModalLabel">Member Details :
                              </h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <i class="fa fa-times"></i>
                              </button>
                          </div>
                          <div class="modal-body">
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Member Name</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="memberForm.controls['MemberName']"
                                              class="form-control">
                                          <div *ngIf="memberForm.controls['MemberName'].hasError('required') && memberForm.controls['MemberName'].touched"
                                              class="form-control-error-custom">
                                              Member Name is required.
                                          </div>
                                          <div *ngIf="memberForm.controls['MemberName'].hasError('pattern') && memberForm.controls['MemberName'].touched"
                                              class="form-control-error-custom">
                                              Member name is invalid.
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-2">
                                      <label class="form-control-label">Designation</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="memberForm.controls['Designation']"
                                              class="form-control">
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Address</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="memberForm.controls['Address']"
                                              class="form-control">
                                      </div>
                                  </div>
  
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">City</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="memberForm.controls['City']" class="form-control">
                                          <div *ngIf="memberForm.controls['City'].hasError('pattern') && memberForm.controls['City'].touched"
                                              class="form-control-error-custom">
                                              City is invalid.
                                          </div>
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">State</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <div class="input-group">
                                              <input [formControl]="memberForm.controls['State']"
                                                  class="form-control">
                                          </div>
                                          <div *ngIf="memberForm.controls['State'].hasError('pattern') && memberForm.controls['State'].touched"
                                              class="form-control-error-custom">
                                              State is invalid.
                                          </div>
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Tel(O)</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="memberForm.controls['TelO']" class="form-control">
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Tel(R)</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="memberForm.controls['TelR']" class="form-control">
                                      </div>
                                  </div>
                              </div>
  
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Fax No</label>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input [formControl]="memberForm.controls['FaxNo']"
                                              class="form-control">
                                      </div>
                                  </div>
  
                                  <div class="col-md-2">
                                      <label class="form-control-label">Mobile Number</label>
                                  </div>
                                  <div class="col-md-4">
                                      <input [formControl]="memberForm.controls['MobileNo']" class="form-control"
                                          pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                                      <div *ngIf="memberForm.controls['MobileNo'].hasError('pattern') && memberForm.controls['MobileNo'].touched"
                                          class="form-control-error-custom">
                                          Mobile Number is not valid.
                                      </div>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Email Id</label>
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </div>
                                  <div class="col-md-4">
                                      <div class="form-group">
                                          <input type="email" [formControl]="memberForm.controls['EmailId']"
                                              class="form-control">
                                          <div *ngIf="memberForm.controls['EmailId'].hasError('required') && memberForm.controls['EmailId'].touched"
                                              class="form-control-error-custom">
                                              Email Id is required.
                                          </div>
                                          <div *ngIf="memberForm.controls['EmailId'].hasError('email') && memberForm.controls['EmailId'].touched && !memberForm.controls['EmailId'].hasError('required')"
                                              class="form-control-error-custom">
                                              Email Id is incorrect.
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="modal-footer">
                              <button id="btnUpdateMember" *ngIf="updateMemberButtonFlag" type="button"
                                  class="btn-sm btn btn-primary" [disabled]="!memberForm.valid || disabledOnclick"
                                  (click)="updateMember()">
                                  <i class="fa fa-save"></i>&nbsp;Update</button>
                              <button id="btnAddMember" *ngIf="!updateMemberButtonFlag" type="button"
                                  class="btn-sm btn btn-primary" [disabled]="!memberForm.valid || disabledOnclick"
                                  (click)="AddMember()">
                                  <i class="fa fa-save"></i>&nbsp;Save</button>
                              <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                  <i class="fa fa-times"></i>&nbsp;Close</button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
  
          <!-- Members Data  -->
          <div class="tab-pane {{attendanceActive}}" id="response" role="tabcard">
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">
                         Response Sheet
                      </span>
                     
                  </div>
                  
                  <div class="card-block datatable-card-block">
  
  
                      <div class="row">
                          <div class="col-md-12">
                              <div class="margin-bottom-50">
                                  <div class="table-responsive">
                                      <table datatable [dtOptions]="dtOptionsAttandance"
                                          [dtTrigger]="dtTriggerAttandance"
                                          class="table table-hover compact cell-border nowrap stripe"
                                          id="AttandanceTable" style="cursor: pointer;">
                                          <thead>
                                              <tr>
                                                  <th>Directors/Committee Members</th>
                                                  <th>Due Date of Response</th>
                                                  <th>Date of Response</th>
                                                  <th>Assent</th>
                                                  <th>Dissent</th>
                                                  <th>Interested & not voted on Resolution</th>
                                                  <th>Not Voted</th>
                                                  <th>Required resolution to be taken in the committee / Board</th>
                                                  
                                              </tr>
                                          </thead>
                                          <tbody>
  
                                              <tr
                                                  *ngFor="let dirVar of Directors; let count = index ">
                                                  <td tabindex="1">{{dirVar.DirectorName}}</td>
                                                  <td tabindex="1">{{PublishDate | date : "dd-MM-y"}}</td>
                                                  <td tabindex="1" *ngIf="dirVar.DueResponseDate !== null || dirVar.DueResponseDate !== undefined">{{dirVar.DueResponseDate | date : "dd-MM-y"}}
                                                  </td>
                                                  <td tabindex="1"><span *ngIf="!dirVar.IsApprove"> - </span><span *ngIf="dirVar.IsApprove"> <i class="fa fa-check text-success"></i></span></td>
                                                  <td tabindex="1"><span *ngIf="!dirVar.IsDisapprove"> - </span><span *ngIf="dirVar.IsDisapprove"> <i class="fa fa-check text-success"></i></span></td>
                                                  <td tabindex="1"><span *ngIf="!dirVar.IsInterested"> - </span><span *ngIf="dirVar.IsInterested"> <i class="fa fa-check text-success"></i></span></td>
                                                  <td tabindex="1"><span *ngIf="!dirVar.IsAbstain"> - </span><span *ngIf="dirVar.IsAbstain"> <i class="fa fa-check text-success"></i></span></td>
                                                  <td tabindex="1"><span *ngIf="!dirVar.IsMeeting"> - </span><span *ngIf="dirVar.IsMeeting"> <i class="fa fa-check text-success"></i></span></td>
                                                  
                                              </tr>
                                          </tbody>
                                          <tfoot>
                                              <tr>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td>{{totalApprove}}</td>
                                                  <td>{{totalDisapprove}}</td>
                                                  <td></td>
                                                  <td></td>
                                                  <td>{{totalIsMeeting}}</td>
                                                  <!-- <td></td>
                                                  <td></td> -->
                                              </tr>
                                          </tfoot>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
  
  
                  <!-- <div class="card-footer">
                     
                      <button id="btnAddMember" type="button"
                          [disabled]="(madeAttendanceButtonValidInvalid || MeetingtimeCheack) || meetingAdjValidation || !disableAdjournedDate || meetingFreezeStatus || disabledOnclick"
                          class="btn-sm btn btn-primary pull-right" (click)="addAttandance()"
                          [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}">
                          <i class="fa fa-save"></i>Save</button>
                  </div> -->
              </section>
          </div>
  
          <!-- This dialogue is for Attendance file proof Upload  -->
          <div class="modal fade modal-size-medium" id="AttandenceMarkDilogue" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel">
                              <i class="fa fa-upload"></i>Upload Proof :
                          </h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="col-md-12">
                              <div class="row">
  
                                  <div class="col-md-4">
                                      <label class="col-form-label" for="l5">Proof of Attendance: </label>
                                  </div>
                                  <div class="col-md-8">
                                      <div class="form-group">
                                          <input type="file" class='form-control'
                                              (change)="fileChangeEvent($event)"
                                              accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt,.pptx, .mp4" />
                                          <span *ngIf="typeHasError" style="color: red">
                                              Please upload valid file format.
                                          </span>
                                      </div>
                                  </div>
  
                                  <!-- <div class="col-md-2">
                                                  <button type="button" class="btn-sm btn btn-default">
                                                      <span class="fa fa-refresh"></span>
                                                  </button>
                                              </div> -->
                              </div>
                          </div>
                          <!-- <div class="margin-bottom-50"> -->
                          <!-- <div class="table-responsive"> -->
                          <!-- <table datatable [dtOptions]="dtOptionsAttandance" [dtTrigger]="dtTriggerAttandance" class="table table-hover compact cell-border nowrap stripe"
                                                          id="AttandanceTable" style="cursor: pointer;">
                                                          <thead>
                                                              <tr>
                                                                  <th>Name</th>
                                                                  <th>Type</th>
                                                                  <th tabindex="1">
                                                                      <div class="md-checkbox">
                                                                          <input id="selectcheckboxall" class="md-checkbox" type="checkbox" />
                                                                          <label for="selectcheckboxall">&nbsp;</label>
                                                                      </div>
                                                                  </th>
                                                              </tr>
                                                          </thead>
                                                          <tbody>
                                                              <tr *ngFor="let dirVar of directorsmemberInvetteeAttended; let count = index ">
                                                                  <td tabindex="1">{{dirVar.membeberName}}</td>
                                                                  <td tabindex="1">{{dirVar.memberType}}</td>
                                                                  <td>
                                                                      <div class="md-checkbox">
                                                                          <input id="selectcheckbox{{count +1 }}" type="checkbox" [(ngModel)]="dirVar.isAttended" (change)="checkselected($event);">
                                                                          <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                                                                      </div>
                                                                  </td>
                                                              </tr>
                                                          </tbody>
                                                      </table> -->
                          <!-- </div> -->
                          <!-- </div> -->
                          <!-- </div>
                                      </div> -->
  
                      </div>
                      <div class="modal-footer">
                          <button id="btnAddMember" type="button" class="btn-sm btn btn-primary"
                              (click)="upload()" [disabled]="disabledOnclick || typeHasError">
                              <i class="fa fa-save"></i>&nbsp;Save</button>
                          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;Close</button>
                      </div>
                  </div>
              </div>
          </div>
  
  
          <div class="tab-pane" id="Process" role="tabcard">
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">Process</span>
                      <div class="pull-right"> </div>
                  </div>
                  <div class="card-block datatable-card-block">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="margin-bottom-50">
                                  <div class="table-responsive">
  
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card-footer">
                      <button id="btnAddMember" type="button" class="btn-sm btn btn-primary pull-right"
                          [disabled]="disabledOnclick">
                          <i class="fa fa-save"></i>&nbsp;Save</button>
                  </div>
              </section>
          </div>
  
          <div class="tab-pane {{documentActive}}" id="DocumentStampGenerator" role="tabcard"
              [ngStyle]="{'opacity':loading === true ? 0.5 : 1}">
              <div class="loader" align="center" *ngIf="loading">
                  <div>
                      <!-- -->
                  </div>
              </div>
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">Documents</span>
                      <div class="pull-right"> </div>
                  </div>
                  <div class="card-block datatable-card-block">
                      <div class="col-md-12">
  
                          <!-- <div class="row">
  
                              <div class="input-group">
                                  <div class="col-md-1">
                                      <label class="form-control-label">Notice:</label>
                                  </div>
                                  <div class="col-md-2">
                                     <div class="form-group">
                                          <div class="input-group" (document:click)="NtimeStamps.close()"
                                              (click)="$event.stopPropagation()">
                                              <input class="form-control" style="padding:6px;z-index: 0;"
                                                  placeholder="dd-mm-yyyy" [minDate]="TodayDate"
                                                  name="MeetingDate" ngbDatepicker #NtimeStamps="ngbDatepicker"
                                                  (click)="NtimeStamps.toggle();AtimeStamps.close();"
                                                  [formControl]="documentForm.controls['noticeDate']">
                                              <button class="input-group-addon"
                                                  (click)="NtimeStamps.toggle();AtimeStamps.close();"
                                                  type="button">
                                                  <span class="fa fa-calendar"
                                                      style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                           
                                  <div class="col-md-2">
                                      <label class="input-group">
                                          <input data-toggle="tooltip"
                                              [title]="(meetingDocumentArray.noticeFile)?meetingDocumentArray.noticeFile.name :'File Not Available'"
                                              [disabled]="true" type="text" class="form-control"
                                              [value]="(meetingDocumentArray.noticeFile)?meetingDocumentArray.noticeFile.name :'File Not Available'">
                                          <span class="input-group-addon default"
                                              *ngIf="meetingDocumentArray.noticeFile && meetingDocumentArray.noticeFile.isAvaible"
                                              (click)="downloadFile(meetingDocumentArray.noticeFile.docId)">
                                              <i class="fa fa-download"></i>
                                          </span>
                                          <span class="input-group-addon warning"
                                              (click)="uploadDocumentModel('notice')"
                                              *ngIf="!meetingFreezeStatus">
                                              <i class="fa fa-upload"></i>
                                          </span>
                                      </label>
                                  </div>
                                  <div class="col-md-4">
                                   
                                      <button class="btn-sm btn btn-primary"
                                          *ngIf="!environmentSettings.PSS && isPublished"
                                          [disabled]="notifyresponse || meetingFreezeStatus"
                                          (click)="sendNotification('Notice')">Notify</button>
                                      <span *ngIf="isNoticeNotify">
                                          <i class="fa fa-check text-success"></i>
                                      </span>
  
                                     
                                  </div>
                                  
                              </div>
                          </div> -->
                          <div class="row">
                              <div class="col-md-1">
                                  <label class="form-control-label">Circular Resolution:</label>
                              </div>
                              <div class="col-md-2">
                                  <div class="form-group">
                                    <div class="input-group" (document:click)="AtimeStamps.close()"
                                          (click)="$event.stopPropagation()">
                                          <input class="form-control" style="padding:6px;z-index: 0;"
                                              placeholder="dd-mm-yyyy" [minDate]="TodayDate" name="MeetingDate"
                                              ngbDatepicker #AtimeStamps="ngbDatepicker"
                                              (click)="AtimeStamps.toggle();"
                                              [formControl]="documentForm.controls['agendaDate']">
                                          <button class="input-group-addon"
                                              (click)="AtimeStamps.toggle();"
                                              type="button">
                                              <span class="fa fa-calendar"
                                                  style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                          </button>
                                      </div> 
                                  </div>
                              </div>
                              <!-- <div class="col-md-2">
                                  <label class="input-group" (focusout)="check($event)">
                                      <input type="text" class="form-control timepicker-init" value='12:00 AM'
                                          [formControl]="documentForm.controls['agendaTime']" id="agendaTime">
                                      <span class="input-group-addon">
                                          <i class="icmn-clock"></i>
                                      </span>
                                  </label>
                              </div> -->
                              <div class="col-md-2">
                                  <label class="input-group">
                                      <input data-toggle="tooltip"
                                          [title]="(meetingDocumentArray.agendaFileArray)?meetingDocumentArray.agendaFileArray.length + ' File(s)':'File Not Available'"
                                          type="text" class="form-control"
                                          [value]="(meetingDocumentArray.agendaFileArray)?meetingDocumentArray.agendaFileArray.length + ' File(s)':'File Not Available'"
                                          [disabled]="true">
                                      <span class="input-group-addon default"
                                          *ngIf="meetingDocumentArray.agendaFileArray && meetingDocumentArray.agendaFileArray.length > 0 && !meetingFreezeStatus"
                                          (click)="uploadDocumentModel('agenda')">
                                          <i class="fa fa-download"></i>
                                      </span>
                                      <span class="input-group-addon warning"
                                          (click)="uploadDocumentModel('agenda')" *ngIf="!meetingFreezeStatus">
                                          <i class="fa fa-upload"></i>
                                      </span>
                                  </label>
                              </div>
                              <div class="col-md-4">
                                  <!-- <button class="btn-sm btn btn-primary"
                                  *ngIf="!environmentSettings.PSS && isPublished" (click)="loadEmailReminderToEdit('5f3fa311da4d83349e2d0fd0')"
                                  [disabled]="notifyresponse || meetingFreezeStatus"
                                  >Template</button> -->
                                  <button class="btn-sm btn btn-primary"
                                      *ngIf="!environmentSettings.PSS"
                                      [disabled]="notifyresponse || meetingFreezeStatus"
                                      (click)="sendNotification('Circular')">Notify</button>
                                  <span *ngIf="isAgendaNotify">
                                      <i class="fa fa-check text-success"></i>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- <div class="card-footer">
                              <button id="btnAddMember" type="button" class="btn-sm btn btn-primary pull-right" (click)="saveDocumentATR()" [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}">
                                  <i class="fa fa-save"></i>Save</button>
                          </div> -->
              </section>
          </div>
  
          <div class="modal fade" id="agendaDelete" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabelForDelete">
                              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="row">
                              <div class="col-sm-12">
                                  Are you sure you want to remove this agenda from the Meeting?
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button type="button" class="btn btn-sm btn-danger" (click)="removeAgendaFromMeeting()"
                              data-dismiss="modal">
                              <i class="fa fa-check"></i>&nbsp;Yes</button>
                          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;No</button>
                      </div>
                  </div>
              </div>
          </div>
  
          <div class="modal fade" id="categoryDelete" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabelForDelete">
                              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="row">
                              <div class="col-sm-12">
                                  Are you sure you want to remove this category from the Meeting also related
                                  agenda will be removed?
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button type="button" class="btn btn-sm btn-danger" (click)="categoryDelete()">
                              <i class="fa fa-check"></i>&nbsp;Yes</button>
                          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;No</button>
                      </div>
                  </div>
              </div>
          </div>
  
          <div class="modal fade" id="complianceDelete" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabelForDelete">
                              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="row">
                              <div class="col-sm-12">
                                  Are you sure you want to remove this Compliance from the Meeting?
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button type="button" class="btn btn-sm btn-danger"
                              (click)="removeComplianceFromMeeting()" data-dismiss="modal">
                              <i class="fa fa-check"></i>&nbsp;Yes</button>
                          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;No</button>
                      </div>
                  </div>
              </div>
          </div>
  
  
          <!-- Dockets -->
  
          <div class="tab-pane {{docketsActive}}" id="Docket" role="tabcard">
              <!-- <section class="card">
                  
                  <div class="tab-pane {{docketsActive}}" id="Docket" role="tabcard">
                      <section class="card">
                          <div class="card-header">
                              <span class="cat__core__title">Dockets</span>
                              <div class="pull-right"> </div>
                          </div>
                          <div class="card-block datatable-card-block">
                              <div class="col-md-12">
                                  <div style="text-align: center;">
                                    {{iframeURL}}
                                      <iframe src='https://view.officeapps.live.com/op/embed.aspx?src=http://localhost:3000/Consolidated_Files/1538566585420-consolidated.doc' width='100%' height='100%' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
                                  </div>
                              </div>
                          </div>
                      </section> -->
              <div class="loader" align="center" *ngIf="loading">
                  <div>
                      <!-- -->
                  </div>
              </div>
              <section class="card">
                  <div class="card-header">
                      <span class="cat__core__title">
                          Generate Agenda History
                      </span>
  
                  </div>
                  <div class="panel-group">
                      <div class=" panel-primary panel-highlighted" style="margin: 0px;">
                          <div class="panel-body">
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Generated Docket File
                                      </label>
                                  </div>
                                  <div class="col-md-6">
                                      <label class="input-group">
                                          <input data-toggle="tooltip" [title]="docketFileName" type="text"
                                              class="form-control" [disabled]="true" [(ngModel)]="docketFileName">
                                          <span class="input-group-addon default"
                                              *ngIf="docketFileName && docketFileId"
                                              (click)="downloadFromHistory(agendaDocData,'docket')">
                                              <!-- <span class="input-group-addon default" *ngIf="docketFileName" (click)="downloadAgendaGeneratedDoc()"> -->
                                              <i class="fa fa-download"></i>
                                          </span>
                                          <!--<span class="input-group-addon warning" (click)="UploadConsolidatedDocs()">
                                                      <i class="fa fa-upload"></i>
                                                  </span> -->
                                      </label>
                                  </div>
                                  <!-- <div class="col-md-6">
                                          <button type="button" class="btn-sm btn btn-primary" (click)="downloadAgendaGeneratedDoc()" [disabled]="!docketFileName">
                                              <i class="fa fa-save"></i>Generate Combined Agenda Word</button>
                                          <button type="button" class="btn-sm btn btn-primary" (click)="UploadConsolidatedDocs()">
                                              <i class="fa fa-save"></i>Upload Combined Agenda Word</button>
                                      </div> -->
                              </div>
                              <!-- <div class="row">
                                          <div class="col-md-3">
  
                                          </div>
                                          <div class="col-md-6">
                                              <button id="saveNoticeDoc" type="button" class="btn-sm btn btn-primary" (click)="downloadAgendaGeneratedDoc()">
                                                  <i class="fa fa-save"></i>Generate Combined Agenda Word</button>
                                              <button id="saveNoticeDoc" type="button" class="btn-sm btn btn-primary" (click)="UploadConsolidatedDocs()">
                                                  <i class="fa fa-save"></i>Upload Combined Agenda Word</button>
                                          </div>
  
                                      </div> -->
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Generated Pdf File
                                      </label>
                                  </div>
                                  <div class="col-md-6">
                                      <label class="input-group">
                                          <input data-toggle="tooltip" [title]="pdfFileName" type="text"
                                              class="form-control" [disabled]="true" [(ngModel)]="pdfFileName">
                                          <span class="input-group-addon default" *ngIf="pdfFileName && pdfFileId"
                                              (click)="downloadFromHistory(agendaDocData,'pdf')">
                                              <!-- <span class="input-group-addon default" *ngIf="pdfFileName" (click)="downloadPdf(pdfFileName)"> -->
                                              <i class="fa fa-download"></i>
                                          </span>
                                          <!-- <span class="input-group-addon warning" (click)="UploadConsolidatedDocs()">
                                                      <i class="fa fa-upload"></i>
                                                  </span> -->
                                      </label>
                                  </div>
                              </div>
  
                              <div class="row">
                                  <div class="col-md-2">
                                      <label class="form-control-label">Generated Minutes File
                                      </label>
                                  </div>
                                  <div class="col-md-6">
                                      <label class="input-group">
                                          <input data-toggle="tooltip" type="text" class="form-control"
                                              [disabled]="true" [(ngModel)]="minutesFileName">
                                          <span class="input-group-addon default" *ngIf="minutesFileName"
                                              (click)="downloadFromHistory(agendaDocData,'Minutes')">
  
                                              <i class="fa fa-download"></i>
                                          </span>
                                      </label>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card-block datatable-card-block">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="margin-bottom-50">
                                  <div class="table-responsive">
                                      <table datatable [dtOptions]="dtOptionsOfAgendaGen"
                                          [dtTrigger]="dtTriggerOfAgendaGen"
                                          class="table table-hover compact cell-border nowrap stripe"
                                          id="AgendaGen" style="cursor: pointer;">
                                          <thead>
                                              <tr>
                                                  <th>Docx Name</th>
                                                  <th>Generation Date</th>
                                                  <th>Generated By</th>
                                                  <th>Action</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr
                                                  *ngFor="let element of agendaGeneratedHistory; let count = index ">
                                                  <td tabindex="1">{{element.displayDocxFilePath}}</td>
                                                  <td tabindex="1">{{element.Date | date : "dd-MM-y hh:mm a"}}
                                                  </td>
                                                  <td tabindex="1">{{element.GeneratedBy}}</td>
                                                  <td tabindex="1">
  
                                                      <a class="btn btn-sm btn-primary"
                                                          (click)="downloadFromHistory(element,'history')"
                                                          *ngIf="docketFileId">
                                                          <!-- <a class="btn btn-sm btn-primary" (click)="downloadFromHistory(element.DocxDocumentID)"> -->
                                                          <span class="fa fa-download"></span>
                                                      </a>
                                                      <!-- <span class="fa fa-download"></span> -->
                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>
          </div>
  
          <div class="tab-pane {{transferToGemActive}}" id="TransferToGemTab" role="tabcard">
              <div class="loader" align="center" *ngIf="loading">
                  <div>
                      <!-- -->
                  </div>
              </div>
              <section class="card" [ngStyle]="{'opacity':loading === true ? 0.5 : 1}">
                  <div class="card-header">
                      <span class="cat__core__title">
                          Transfer to GEM
                      </span>
                      <span style="float: right">
                          <div class="btn-group" role="group" aria-label="Basic example">
                              <!-- <button type="button" class="btn btn-sm btn-primary" (click)="addAgendaPageRedirection()" [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                                      <i class="fa fa-plus"></i> Add Agenda</button> -->
                              <button type="button" class="btn-sm btn btn-primary" (click)="publishAgendaToGem()"
                                  [disabled]="meetingFreezeStatus">
                                  <i class="fa fa-save"></i>Publish</button> &nbsp;&nbsp;
                              <button type="button" class="btn btn-sm btn-primary"
                                  [disabled]="meetingFreezeStatus" data-toggle="modal"
                                  data-target="#agendaAccessModal" (click)="getAgendaAccessRights()"
                                  style="display:none">
                                  <i class="fa fa-save"></i>Access</button>
                          </div>
                      </span>
                  </div>
  
                  <div class="card-block datatable-card-block">
                      <div class="col-lg-12">
                          <div class="table-responsive ">
                              <table datatable [dtOptions]="dtOptionsOfTransferToGem"
                                  [dtTrigger]="dtTriggerOfTransferToGem"
                                  class="table table-hover compact cell-border nowrap stripe"
                                  id="transferToGemTable" style="cursor: pointer;">
                                  <thead>
                                      <tr>
                                          <th style="display:none;">Agenda Order</th>
                                          <th style="display:none;">ID</th>
                                          <th style="width:10%">
                                              <div class="md-checkbox">
                                                  <input id="selectallcheckbox" class="md-checkbox"
                                                      type="checkbox" (change)="selectAllAgendas($event);" />
                                                  <label for="selectallcheckbox">
                                                      <!-- <b>(Select)</b>&nbsp; -->
                                                  </label>
                                              </div>
                                          </th>
                                          <th style="width:5%">Agenda Number</th>
                                          <th style="width:20%">Agenda Title</th>
                                          <th style="width:5%">Group Number</th>
                                          <th style="width:10%">Group Name</th>
                                          <th style="width:20%">Agenda Document</th>
                                          <th style="width:10%">Minute Document</th>
                                          <th style="width:20%">Attachment</th>
                                          <!-- <th style="width:10%">Access Right</th> -->
                                          <th style="width:10%">Status</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr *ngFor="let agenda of transferToGemArray; let count=index">
  
                                          <td style="display:none;">{{agenda.Agendaorder}}</td>
                                          <td style="display:none;">{{agenda._id}}</td>
                                          <td style="width:10%">
                                              <div class="md-checkbox">
                                                  <input id="selectcheckbox1{{count +1 }}" type="checkbox"
                                                      [(ngModel)]="agenda.isPublished"
                                                      (change)="checkselectedAgenda($event, count, agenda._id);"
                                                      [disabled]="agenda.setSelected == true">
                                                  <label for="selectcheckbox1{{count +1 }}">&nbsp;</label>
                                              </div>
                                          </td>
                                          <td tabindex="1" class="reOrderRow" style="width:5%">
                                              {{agenda.AgendaNumber}}
                                          </td>
  
                                          <td tabindex="1" class="reOrderRow" style="width:25%">
                                              {{agenda.AgendaTitle}}
                                          </td>
                                          <td tabindex="1" class="reOrderRow" style="width:5%">
                                              {{agenda.groupNumber}}
                                          </td>
  
                                          <td tabindex="1" class="reOrderRow" style="width:10%">
                                              {{agenda.groupName}}
                                          </td>
                                          <td style="width:20%">
                                              <label class="input-group">
                                                  <input data-toggle="tooltip" type="text"
                                                      [value]="agenda.AgendaGenerationDocument ? agenda.AgendaGenerationDocument.DocName : 'File Not Available'"
                                                      class="form-control" [disabled]="true">
  
                                                  <span
                                                      *ngIf="agenda.AgendaGenerationDocument && agenda.AgendaGenerationDocument.IsAvailable && agenda.AgendaGenerationDocument.DocName != 'File Not Available' && agenda.AgendaGenerationDocument.DocName != ''"
                                                      (click)="downloadAgendaDocs(agenda.AgendaGenerationDocument.DocumentManagementID, agenda._id, 'Agenda')"
                                                      class="input-group-addon default">
                                                      <i class="fa fa-download"></i>
                                                  </span>
                                                  <span class="input-group-addon warning"
                                                      (click)="initiateUploadAgendaDocs(agenda, 'Agenda')"
                                                      *ngIf="!meetingFreezeStatus">
                                                      <i class="fa fa-upload"></i>
                                                  </span>
  
                                              </label>
                                          </td>
                                          <td style="width:10%">
                                              <label class="input-group">
                                                  <input data-toggle="tooltip" type="text"
                                                      [value]="agenda.AgendaMinuteDocument ? agenda.AgendaMinuteDocument.DocName : 'File Not Available'"
                                                      class="form-control" [disabled]="true">
  
                                                  <span
                                                      *ngIf="agenda.AgendaMinuteDocument && agenda.AgendaMinuteDocument.IsAvailable && agenda.AgendaMinuteDocument.DocName != 'File Not Available' && agenda.AgendaMinuteDocument.DocName != ''"
                                                      (click)="downloadAgendaDocs(agenda.AgendaMinuteDocument.DocumentManagementID, agenda._id, 'Minute')"
                                                      class="input-group-addon default">
                                                      <i class="fa fa-download"></i>
                                                  </span>
                                                  <span class="input-group-addon warning"
                                                      (click)="initiateUploadAgendaDocs(agenda, 'Minutes')"
                                                      *ngIf="!meetingFreezeStatus">
                                                      <i class="fa fa-upload"></i>
                                                  </span>
  
                                              </label>
                                          </td>
                                          <td style="width:20%">
                                              <label class="input-group">
                                                  <input data-toggle="tooltip" type="text"
                                                      [value]="agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length > 0 ? agenda.AgendaGenerationPdf.length + ' Files': 'File Not Available'"
                                                      class="form-control" [disabled]="true">
                                                  <span class="input-group-addon warning"
                                                      (click)="initiateUploadAgendaPdf(agenda)"
                                                      *ngIf="!meetingFreezeStatus">
                                                      <i class="fa fa-upload"></i>
                                                  </span>
  
                                              </label>
                                          </td>
                                          <!-- <td>
                                                  <a href="javascript: void(0);" (click)="getAgendaAccessRights('View')">View</a> /
                                                  <a href="javascript: void(0);" (click)="getAgendaAccessRights('Edit')">Edit</a>
                                              </td> -->
  
                                          <td tabindex="4" style="width:10%">
  
                                              {{agenda.transferToGemTime | date : "dd-MM-y hh:mm a"}}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
  
              </section>
              <div class="modal-footer" [ngStyle]="{'opacity':loading === true ? 0.5 : 1}">
  
                  <button type="button" class="btn btn-sm btn-primary" (click)="hideMeetingFromGem()"
                      [disabled]="meetingFreezeStatus" style="display:none">
                      <i class="fa fa-save"></i>{{hideOrShowBtnMsg}}</button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="cnfrmFreezeMeeting()"
                      style="display:none">
                      <i class="fa fa-save"></i>{{freezeBtnMsg}}</button>
  
                  <button id="test" type="button" class="btn btn-sm btn-primary"
                      (click)="generateConsolidatedPdf()" [disabled]="meetingFreezeStatus">
                      <i class="fa fa-save"></i>Generate Consolidated Pdf</button>
                  <!-- <button type="button" class="btn btn-sm btn-primary" href="javascript: void(0);" (click)="transferPdfToGem()" [disabled]="pdfFileName == null || pdfFileName == undefined || meetingFreezeStatus">
                      <i class="fa fa-save"></i>Transfer PDF to GEM</button> -->
                  <button id="btnSaveInviteesInMeeting" type="button" class="btn btn-sm btn-primary"
                      (click)="transferToGemSaveOrder()" [disabled]="meetingFreezeStatus || disabledOnclick">
                      <i class="fa fa-save"></i>Save Order</button>
              </div>
          </div>
  
      </div>
  
  
      <!-- START CircularResolution> Document Multiple file uplaod dialoge -->
      
      <div class="modal fade modal-size-medium" id="CircularResolutionUploadDialog" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">
                          <i class="fa fa-upload"></i>
                          <span id="CircularResolutionUploadDialog_documentUploadTitle"></span>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="col-md-12">
                          <div class="row collapse1">
                              <span class="cat__core__title">
                                  Existing Files
                              </span>
      
                              <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                                  <thead>
                                      <tr>
      
                                          <th>Filename</th>
                                          <th>Action</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr
                                          *ngFor="let agendafile of this.meetingDocumentArray.agendaFileArray; let count=index">
      
                                          <td tabindex="1" style="cursor: move; width: 70%;">
                                              {{agendafile.name}}
                                          </td>
                                          <td>
                                              <button type="button" class="btn-sm btn btn-warning"
                                                  (click)="downloadDoc(agendafile.docId)">
                                                  <span class="fa fa-download"></span>
                                              </button>
                                              <!-- <button type="button" class="btn-sm btn btn-warning">
                                                          <span class="fa fa-download"></span>
                                                  </button> -->
      
      
                                              <button type="button" class="btn-sm btn btn-danger"
                                                  (click)="deleteDocument('agenda', agendafile.docId)">
                                                  <!-- deletePdfAttachment(agendafile._id//CHECK WAHT IS THIS ID,agendafile.docId) -->
                                                  <span class="fa fa-close"></span>
                                              </button>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <div class="row">
                                  <div class="col-md-4">
                                      <label class="col-form-label" for="l5">
                                          <span id="CircularResolutionUploadDialog_documentUploadLable"></span>
                                      </label>
                                  </div>
                                  <div class="col-md-8">
                                      <div class="form-group">
                                          <input type="file" class='form-control fileUpload'
                                              (change)="fileChangeEvent($event)"
                                              accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"
                                              multiple />
                                          <span *ngIf="typeHasError" style="color: red">
                                              Please upload valid file format.
                                          </span>
      
                                      </div>
                                      <!-- {{fileHasError | json}} -->
                                  </div>
                              </div>
      
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
      
                      <button id="CircularResolutionUploadDialog_saveAgendaDoc" type="button" class="btn-sm btn btn-primary"
                          (click)="uploadDocFile('agenda')">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
      
                      <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                          <i class="fa fa-times"></i>&nbsp;Close</button>
      
                  </div>
              </div>
          </div>
      </div>
      <!-- END CircularResolution> Document Multiple file uplaod dialoge -->
  
  
      <div class="modal fade modal-size-medium" id="documentFilesUploadDialog" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">
                          <i class="fa fa-upload"></i>
                          <span id="documentUploadTitle"></span>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="col-md-12">
                          <div class="row">
  
                              <div class="col-md-4">
                                  <label class="col-form-label" for="l5">
                                      <span id="documentUploadLable"></span>
                                  </label>
                              </div>
                              <div class="col-md-8">
                                  <div class="form-group">
                                      <input type="file" class='form-control fileUpload'
                                          (change)="fileChangeEvent($event)"
                                          accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt,.pptx, .mp4" />
                                      <span *ngIf="typeHasError" style="color: red">
                                          Please upload valid file format.
                                      </span>
                                  </div>
  
                              </div>
  
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
  
                      <button id="saveNoticeDoc" type="button" class="btn-sm btn btn-primary"
                          (click)="uploadDocFile('notice')" [disabled]="typeHasError">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
  
                      <button id="saveDraftDoc" type="button" class="btn-sm btn btn-primary"
                          (click)="uploadDocFile('draft')" [disabled]="typeHasError">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
  
                      <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary"
                          (click)="uploadDocFile('agenda')" [disabled]="typeHasError">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
  
                      <button id="saveFinalDoc" type="button" class="btn-sm btn btn-primary"
                          (click)="uploadDocFile('final')" [disabled]="typeHasError">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
  
                      <button id="saveATRDoc" type="button" class="btn-sm btn btn-primary"
                          (click)="uploadDocFile('ATR')" [disabled]="typeHasError">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
  
                      <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                          <i class="fa fa-times"></i>&nbsp;Close</button>
  
                  </div>
              </div>
          </div>
      </div>
  
      <div class="modal fade modal-size-medium" id="agendaDocxUploadDialog" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">
                          <i class="fa fa-upload"></i>
                          <span id="AgendaDocumentUploadTitle"></span>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="col-md-12">
                          <div class="row">
  
                              <div class="col-md-4">
                                  <label class="col-form-label" for="l5">
                                      <span>Agenda Document
                                          <span _ngcontent-c2="" style="color: red;">*</span>
                                      </span>
                                  </label>
                              </div>
                              <div class="col-md-8">
                                  <div class="form-group">
                                      <input type="file" class='form-control fileUpload' accept=".docx,.pdf"
                                          (change)="agendaDocsChangeEvent($event)" />
                                      <span *ngIf="typeHasError" style="color: red">
                                          Only DOCX Type File is allowed to upload.
                                      </span>
  
                                  </div>
                              </div>
  
                          </div>
  
                          <div class="row" *ngIf="!isCategoryGlobal && isPSSMasterAgenda">
                              <div class="col-md-4">
                                  <label class="col-form-label" for="l5">
                                      <span>Company Name
                                          <span _ngcontent-c2="" style="color: red;">*</span>
                                      </span>
                                  </label>
                              </div>
                              <div class="col-md-8">
                                  <div class="form-group scroll-area">
                                      <div class="md-checkbox mb-20"
                                          *ngFor="let CND of companyNameData; let i = index">
                                          <input id="companyCheck{{i}}" class='chkCompanyName' type="checkbox"
                                              value="{{CND.id}}" name="{{CND.id}}"
                                              (change)="changeCompanyNameData($event,CND.id)">
                                          <label for="companyCheck{{i}}">
                                              <span class="comp-name">{{CND.name}}</span>
                                          </label>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
  
                      <!-- <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" [disabled]="typeHasError" (click)="uploadAgendaDocFile()">
                          <i class="fa fa-save"></i>Upload</button> -->
                      <button id="replaceLibraryAgendaDoc" type="button" class="btn-sm btn btn-primary"
                          [disabled]="typeHasError" (click)="uploadAgendaDocFile($event)"
                          *ngIf="isLibraryAgenda=='Yes' && !isPSSMasterAgenda || !uploadAgendaDocFileBtn">
                          <i class="fa fa-save"></i>Replace in Library too</button>
  
                      <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary"
                          [disabled]="typeHasError" (click)="uploadAgendaDocFile($event)"
                          *ngIf="uploadAgendaDocFileBtn">
                          <i class="fa fa-save"></i>Upload only in meeting</button>
  
                      <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                          <i class="fa fa-times"></i>Close</button>
  
                  </div>
              </div>
          </div>
      </div>
  
      <div class="modal fade modal-size-medium" id="agendaPdfUploadDialog" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">
                          <i class="fa fa-upload"></i>
                          <span id="AgendaPdfUploadTitle"></span>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="col-md-12">
                          <div class="row collapse1">
                              <span class="cat__core__title">
                                  Existing Files
                              </span>
  
                              <table class="table table-hover compact cell-border nowrap stripe"
                                  style="cursor: pointer;">
                                  <thead>
                                      <tr>
  
                                          <th>Filename</th>
                                          <th>Action</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr *ngFor="let agenda of agendaPdfAttachment; let count=index">
  
                                          <td tabindex="1" style="cursor: move; width: 70%;">
                                              {{agenda.PdfName}}
                                          </td>
                                          <td>
                                              <button type="button" class="btn-sm btn btn-warning"
                                                  (click)="downloadDoc(agenda.DocumentManagementID)">
                                                  <span class="fa fa-download"></span>
                                              </button>
                                              <!-- <button type="button" class="btn-sm btn btn-warning">
                                                          <span class="fa fa-download"></span>
                                                  </button> -->
  
                                              <button type="button" class="btn-sm btn btn-danger"
                                                  (click)="deletePdfAttachment(agenda._id,agenda.DocumentManagementID)">
                                                  <span class="fa fa-close"></span>
                                              </button>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <div class="row">
                                  <div class="col-md-4">
                                      <label class="col-form-label" for="l5">
                                          <span>Agenda Attachment
                                              <span _ngcontent-c2="" style="color: red;">*</span>
                                          </span>
                                      </label>
                                  </div>
                                  <div class="col-md-8">
                                      <div class="form-group">
                                          <input type="file" class='form-control fileUpload'
                                              (change)="agendaPdfChangeEvent($event)"
                                              accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"
                                              multiple />
                                          <span *ngIf="typeHasError" style="color: red">
                                              Please upload valid file format.
                                          </span>
  
                                      </div>
                                      <!-- {{fileHasError | json}} -->
                                  </div>
                              </div>
  
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
  
                      <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary"
                          (click)="uploadAgendaPdfFile()">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
  
                      <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                          <i class="fa fa-times"></i>&nbsp;Close</button>
  
                  </div>
              </div>
          </div>
      </div>
  
      <div class="modal fade modal-size-medium" id="consolidatedDocxUploadDialog" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">
                          <i class="fa fa-upload"></i>
                          <span id="ConsolidatedDocumentUploadTitle"></span>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="col-md-12">
                          <div class="row">
  
                              <div class="col-md-4">
                                  <label class="col-form-label" for="l5">
                                      <span>Agenda Document
                                          <span _ngcontent-c2="" style="color: red;">*</span>
                                      </span>
                                  </label>
                              </div>
                              <div class="col-md-8">
                                  <div class="form-group">
                                      <input type="file" class='form-control fileUpload' accept=".docx"
                                          (change)="consolidatedDocsChangeEvent($event)" />
                                      <span *ngIf="typeHasError" style="color: red">
                                          Only DOCX Type File is allowed to upload.
                                      </span>
  
                                  </div>
                                  <!-- {{fileHasError | json}} -->
  
                              </div>
  
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
  
                      <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary"
                          [disabled]="typeHasError" (click)="uploadConsolidatedFile()">
                          <i class="fa fa-save"></i>&nbsp;Upload</button>
  
                      <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                          <i class="fa fa-times"></i>&nbsp;Close</button>
  
                  </div>
              </div>
          </div>
      </div>
  
      <div class="modal fade modal-size-medium" id="agendaMinutesUploadDialog" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">
                          <i class="fa fa-upload"></i>
                          <span id="MinuteDocumentUploadTitle"></span>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="col-md-12">
                          <div class="row">
                              <div class="col-md-4">
                                  <label class="col-form-label" for="l5">
                                      <span>Minute Document
                                          <span _ngcontent-c2="" style="color: red;">*</span>
                                      </span>
                                  </label>
                              </div>
                              <div class="col-md-8">
                                  <div class="form-group">
                                      <input type="file" class='form-control fileUpload' accept=".docx"
                                          (change)="minutesDocsChangeEvent($event)" />
                                      <span *ngIf="typeHasError" style="color: red">
                                          Only DOCX Type File is allowed to upload.
                                      </span>
  
                                  </div>
                              </div>
                          </div>
                          <div class="row" *ngIf="!isCategoryGlobal && isPSSMasterAgenda">
                              <div class="col-md-4">
                                  <label class="col-form-label" for="l5">
                                      <span>Company Name
                                          <span _ngcontent-c2="" style="color: red;">*</span>
                                      </span>
                                  </label>
                              </div>
                              <div class="col-md-8">
                                  <div class="form-group scroll-area">
                                      <div class="md-checkbox mb-20"
                                          *ngFor="let CND of companyNameData; let i = index">
                                          <input id="companyCheckMin{{i}}" class="chkCompanyNameMinutes"
                                              type="checkbox" value="{{CND.id}}" name="{{CND.id}}"
                                              (change)="changeCompanyNameData($event,CND.id)">
                                          <label for="companyCheckMin{{i}}">
                                              <span class="comp-name">{{CND.name}}</span>
                                          </label>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button id="saveMinuteDocInLibrary" type="button" class="btn-sm btn btn-primary"
                          [disabled]="typeHasError" (click)="uploadMinutesDocFile($event)"
                          *ngIf="isLibraryAgenda=='Yes' && !isPSSMasterAgenda || !uploadAgendaDocFileBtn">
                          <i class="fa fa-save"></i>Replace in Library too</button>
                      <button id="saveMinuteDoc" type="button" class="btn-sm btn btn-primary"
                          [disabled]="typeHasError" (click)="uploadMinutesDocFile($event)"
                          *ngIf="uploadAgendaDocFileBtn">
                          <i class="fa fa-save"></i>Upload only in meeting</button>
  
                      <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                          <i class="fa fa-times"></i>Close</button>
  
                  </div>
              </div>
          </div>
      </div>
  
      <!-- Split Agenda Modal -->
      <div class="modal fade" id="splitAgenda" role="dialog" tabindex="-1">
          <div class="modal-dialog  modal-full">
  
              <!-- Modal content-->
              <div class="modal-content">
                  <div class="modal-header">
                      <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
                      <h4 class="modal-title">Split Agenda</h4>
                  </div>
  
                  <div class="table-responsive " style="float:left;overflow-y: auto">
                      <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                          <thead>
                              <tr>
                                  <th colspan="3"
                                      style="text-align: center; border-right: 1px;border-right-color: #37669e;border-right-style: inset;">
                                      New</th>
                                  <th style="text-align: center">Old</th>
                              </tr>
                              <tr>
                                  <!-- <th style="width:5%"></th> -->
                                  <th style="width:5%">Agenda Number</th>
                                  <th style="width:30%">Agenda Title</th>
                                  <th
                                      style="border-right: 1px;border-right-color: #37669e;border-right-style: inset; width: 15%">
                                      Action</th>
                                  <th style="width:50%">Select</th>
                                  <!-- <th>Agenda Number</th>
                                      <th>Agenda Title</th> -->
                                  <!-- <th>Action</th> -->
                              </tr>
  
                          </thead>
                          <tbody>
                              <tr *ngFor="let splitData of splittedData; let count = index;">
                                  <!-- <td style="width:5%">
                                          <div class="md-checkbox">
                                              <input id="selectSplitAgenda{{count +1 }}" type="checkbox" [(ngModel)]="splitData.isChanged" [ngModelOptions]="{standalone: true}">
                                              <label for="selectSplitAgenda{{count +1 }}">&nbsp;</label>
                                          </div>
                                      </td> -->
                                  <td style="width:5%">
                                      {{splitData.AgendaNumber}}
                                  </td>
  
                                  <td style="width:30%">
                                      {{splitData.AgendaTitle}}
                                  </td>
                                  <td
                                      style="border-right: 1px;border-right-color: #37669e;border-right-style: inset; width: 15%">
                                      <button id="isNew_{{count +1}}" type="button" class="btn-sm btn btn-primary"
                                          (click)="selectNewOrExisting('new',splitData.AgendaNumber,splitData.AgendaTitle,splitData.FileName,splitData.DocumentManagementID,splitData._id, count)">
                                          <span>New</span>
                                      </button>
                                      <button id="isExisting_{{count +1}}" type="button"
                                          class="btn-sm btn btn-warning"
                                          (click)="selectNewOrExisting('Existing',splitData.AgendaNumber,splitData.AgendaTitle,splitData.FileName,splitData.DocumentManagementID,splitData._id, count)">
                                          <span>Existing</span>
                                      </button>
                                      <!-- <div class="input-group">
                                                  <div class="md-radio md-radio-inline">
                                                      <input id="isNew_{{count +1}}" type="radio" style="position:absolute" [ngModelOptions]="{standalone: true}" name="newOrExisting"
                                                          [(ngModel)]="newOrExisting" value='new'
                                                          class="form-check-input" (click)="selectNewOrExisting('new',splitData.AgendaNumber,splitData.AgendaTitle,splitData.FileName,splitData.DocumentManagementID,splitData._id)">
                                                      <label for="isNew_{{count +1}}">New</label>
                                                  </div>
                                                  <div class="md-radio md-radio-inline">
                                                      <input id="isExisting_{{count +1}}" type="radio" style="position:absolute" [ngModelOptions]="{standalone: true}" name=" newOrExisting"
                                                          [(ngModel)]="newOrExisting" value='Existing'
                                                          class="form-check-input" (click)="selectNewOrExisting('Existing',splitData.AgendaNumber,splitData.AgendaTitle,splitData.FileName,splitData.DocumentManagementID,splitData._id)">
                                                      <label for="isExisting_{{count +1}}">Existing</label>
                                                  </div>
                                              </div> -->
                                  </td>
                                  <td style="width:50%">
                                      <!-- <div class="form-group" *ngIf="splitData.isChanged == true || splitData.isExisting == true">
                                              <select id="replace_{{count +1}}" class="form-control select" name="agendaToReplace" [(ngModel)]="splitData.replaceBy" [disabled]="!splitData.isExisting"
                                                  (change)="disableAddedAgenda()">
                                                  <option value="" [selected]="true">Select</option>
                                                  <option *ngFor="let agenda of agendaArray" value="{{agenda._id}}" [disabled]="agenda.isDisabled">
                                                      {{agenda.AgendaNumber}} - {{agenda.AgendaTitle}}
                                                  </option>
                                              </select>
                                              <button type="button" class="btn-sm btn btn-default" (click)="revertAgendaSelection(count)">
                                                  <span class="fa fa-refresh"></span>
                                              </button>
                                          </div> -->
  
                                      <div class="input-group" *ngIf="splitData.isExisting == true">
                                          <select id="replace_{{count +1}}" class="form-control select"
                                              name="agendaToReplace" [(ngModel)]="splitData.replaceBy"
                                              (change)="disableAddedAgenda()">
                                              <option value="" [selected]="true">Select</option>
                                              <option *ngFor="let agenda of agendaArray" value="{{agenda._id}}"
                                                  [disabled]="agenda.isDisabled">
                                                  {{agenda.AgendaNumber}} - {{agenda.AgendaTitle}}
                                              </option>
                                          </select>
                                          <!-- <div class="input-group-append">
                                                  <button type="button" class="btn-sm btn btn-default" (click)="revertAgendaSelection(count)">
                                                      <span class="fa fa-refresh"></span>
                                                  </button>
                                              </div> -->
                                      </div>
  
                                      <div *ngIf="splitData.isExisting == false">
                                          <input type="text" [(ngModel)]="splitData.replaceBy" hidden>
                                          <span>NEW</span>
                                      </div>
                                  </td>
                                  <!-- <td>{{splitData.oldAgendaNumber}}</td>
                                      <td>{{splitData.oldAgendaTitle}}</td> -->
                                  <!-- <td>
                                          <button type="button" class="btn-sm btn btn-success" data-toggle="modal">
                                              <span>Ok</span>
                                          </button>
                                      </td> -->
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-success" (click)="saveSplittedAgenda()">Save</button>
                      <button type="button" class="btn btn-default"
                          (click)="deleteSplitTemporaryData()">Close</button>
                  </div>
              </div>
  
          </div>
      </div>
      <!-- Split Agenda Modal Close -->
  
  
      <!-- Confirm New / Existing Agenda Modal -->
      <div class="modal fade modal-size-medium" id="newOrExistingModal" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <form class="well">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel">
                              <i class="fa fa-plus"></i>New / Existing</h5>
                      </div>
                      <div class="modal-body">
                          <span id="newOrExixtingModalMsg"></span>
                          <div class="row" *ngIf="isExisting">
                              <div class="col-md-3">
                                  <label class="form-control-label" for="l0">Select Agenda To Replace</label>
                              </div>
                              <div class="col-md-9">
                                  <div class="form-group">
                                      <select class="form-control select" name="agendaToReplace"
                                          [(ngModel)]="agendaToReplace">
                                          <option value="" [selected]="true">Select</option>
                                          <option *ngFor="let agenda of agendaArray" value="{{agenda._id}}">
                                              {{agenda.AgendaNumber}} - {{agenda.AgendaTitle}}
                                          </option>
                                      </select>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button id="btnsaveCategory" type="Submit" class="btn-sm btn btn-primary"
                              (click)="saveSplittedAgenda()"
                              [disabled]="!agendaToReplace && isExisting == true || disabledOnclick">
                              <i class="fa fa-save"></i>&nbsp;Save
                          </button>
                          <button type="button" class="btn btn-sm" data-dismiss="modal" data-toggle="modal"
                              data-target="#splitAgenda">
                              <i class="fa fa-times"></i>&nbsp;Close
                          </button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
      <!-- Confirm New / Existing Agenda Modal Close -->
  
  
      <div class="modal fade" id="deletePdfConfirmation" tabindex="-1" role="dialog" data-backdrop="static"
          data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabelForDeletion">
                          <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-sm-12">
                              Are you sure you want to delete attachment?
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger" (click)="removeDoc()"
                          data-dismiss="modal">
                          <i class="fa fa-check"></i>&nbsp;Yes</button>
                      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                          <i class="fa fa-times"></i>&nbsp;No</button>
                  </div>
              </div>
          </div>
      </div>
  
      <div class="modal fade" id="hideAgendaConfirmation" tabindex="-1" role="dialog" data-backdrop="static"
          data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="">
                          <i class="fa fa-warning"></i>Warning</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-sm-12" id="hideMessage">
  
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger" (click)='clickOnhideOk()'
                          id="removeAgenda" data-dismiss="modal">
                          <i class="fa fa-check"></i>&nbsp;{{hideBtnMsg}} Meeting</button>
                      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                          <i class="fa fa-times"></i>&nbsp;No</button>
  
                  </div>
              </div>
          </div>
      </div>
  
      <div class="modal fade" id="confirmTransferPdfGem" tabindex="-1" role="dialog" data-backdrop="static"
          data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="confirm">
                          <!-- <i class="fa fa-warning"></i>-->
                          Transfer PDF</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-sm-12">
                              <span>Do you want to transfer combined PDF to GEM?</span>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-primary" (click)='clickTransferPdf()'
                          id="removeAgenda" data-dismiss="modal">
                          <i class="fa fa-check"></i>&nbsp;Transfer</button>
                      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                          <i class="fa fa-times"></i>&nbsp;No</button>
  
                  </div>
              </div>
          </div>
      </div>
      <div class="modal fade" id="freezeMeetingCnfrm" tabindex="-1" role="dialog" data-backdrop="static"
          data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="">
                          <i class="fa fa-warning"></i>&nbsp;Warning</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button"
                          (click)="cancelMeetingFreeze()">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-sm-12" id="freezeMessage">
  
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger" (click)='freezeMeeting()' id="freezeId"
                          data-dismiss="modal">
                          <i class="fa fa-check"></i>&nbsp;{{freezeBtnMsg}}</button>
                      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                          (click)="cancelMeetingFreeze()">
                          <i class="fa fa-times"></i>&nbsp;No</button>
  
                  </div>
              </div>
          </div>
      </div>
  
      <!-- AgendaAccessModal -->
      <!-- <div class="modal fade modal-size-large" id="agendaAccessModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
              aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel">
                              <i class="fa fa-plus"></i>Access Rights</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body modal-body-noBodyPadding">
                          <div class="card-block datatable-card-block">
                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="margin-bottom-50">
                                          <div class="table-responsive">
                                              <table datatable [dtOptions]="dtOptionsOfAgendaAccess" [dtTrigger]="dtTriggerAgendaAccess" class="table table-hover compact cell-border nowrap stripe"
                                                  id="agendaAccessTable" style="cursor: pointer;">
                                                  <thead>
                                                      <tr>
                                                          <th style="display: none;">Agenda Id</th>
                                                          <th>
                                                              <div class="md-checkbox">
                                                                  <input id="selectAllAccess" class="md-checkbox" [ngModelOptions]="{standalone: true}" type="checkbox" [(ngModel)]="selectAllAccess"
                                                                      (change)="selectAllUsersForAllAgenda($event);" />
                                                                  <label for="selectAllAccess">&nbsp;</label>
                                                              </div>
                                                          </th>
                                                          <th>Agenda Number</th>
                                                          <th>Agenda Title</th>
                                                          <th>Directors</th>
                                                          <th>Members</th>
                                                          <th>Invitees</th>
                                                      </tr>
                                                  </thead>
                                                  <tbody>
                                                      <tr *ngFor="let agenda of agendaArray;let count=index">
                                                          <td style="display: none;" tabindex="1">{{agenda._id}}</td>
                                                          <td>
                                                              <div class="md-checkbox">
                                                                  <input id="selectAgendaStorecheckbox{{count +1 }}" type="checkbox" [(ngModel)]="agenda.selectAccessAgenda" [ngModelOptions]="{standalone: true}"
                                                                      (change)="selectAllUsersPerAgenda($event)">
                                                                  <label for="selectAgendaStorecheckbox{{count +1 }}">&nbsp;</label>
                                                              </div>
                                                          </td>
                                                          <td tabindex="1">{{agenda.AgendaNumber}}</td>
                                                          <td tabindex="1">{{agenda.AgendaTitle}}</td>
                                                          <td tabindex="1">
                                                              <table>
                                                                  <tr *ngFor="let dir of agenda.AgendaAccessRights;let ind=index">
                                                                      <td style="padding: 0px; border: none !important;" *ngIf="dir.UserType == 'Director'" class="md-checkbox">
                                                                          <input id="selectAgendaDirectorAccesscheckbox_{{count +1}}_{{ind +1 }}" type="checkbox" [(ngModel)]="dir.View" [ngModelOptions]="{standalone: true}"
                                                                              (change)="selectIndividualUserAccess($event, dir._id, count)" >
                                                                          <label for="selectAgendaDirectorAccesscheckbox_{{count +1}}_{{ind +1 }}">{{dir.UserName}}</label>
                                                                      </td>
                                                                  </tr>
                                                              </table>
                                                          </td>
  
                                                          <td>
                                                              <table>
                                                                  <tr *ngFor="let mem of agenda.AgendaAccessRights;let ind=index">
                                                                      <td style="padding: 0px; border: none !important;" *ngIf="mem.UserType == 'Member'" class="md-checkbox">
                                                                          <input id="selectAgendaInviteeAccesscheckbox_{{count +1}}_{{ind +1 }}" type="checkbox" [(ngModel)]="mem.View" [ngModelOptions]="{standalone: true}"
                                                                              (change)="selectIndividualUserAccess($event, mem._id, count)" >
                                                                          <label for="selectAgendaInviteeAccesscheckbox_{{count +1}}_{{ind +1 }}">{{mem.UserName}}</label>
                                                                      </td>
                                                                  </tr>
                                                              </table>
                                                          </td>
                                                          <td tabindex="1">
                                                              <table>
                                                                  <tr *ngFor="let inv of agenda.AgendaAccessRights;let ind=index">
                                                                      <td style="padding: 0px; border: none !important;" *ngIf="inv.UserType == 'Invitees'" class="md-checkbox">
                                                                          <input id="selectAgendaMemberAccesscheckbox_{{count +1}}_{{ind +1 }}" type="checkbox" [(ngModel)]="inv.View" [ngModelOptions]="{standalone: true}"
                                                                              (change)="selectIndividualUserAccess($event, inv._id, count)" >
                                                                          <label for="selectAgendaMemberAccesscheckbox_{{count +1}}_{{ind +1 }}">{{inv.UserName}}</label>
                                                                      </td>
                                                                  </tr>
                                                              </table>
                                                          </td>
                                                      </tr>
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button id="btnsaveAgenda" type="button" (click)="updateAgendaAccess()" class="btn-sm btn btn-primary">
                              <i class="fa fa-save"></i>Update Access
                          </button>
                          <button type="button" class="btn btn-sm" data-dismiss="modal">
                              <i class="fa fa-times"></i>Close
                          </button>
                      </div>
                  </div>
              </div>
          </div> -->
  
      <div class="modal fade modal-size-large" id="agendaAccessModal" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog custom-modal" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel">
                          <i class="fa fa-plus"></i>Access Rights</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button"
                          (click)="closeAccessRightsPopUp()">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body modal-body-noBodyPadding">
                      <div class="card-block datatable-card-block">
                          <div class="row">
                              <div class="col-md-12">
                                  <div class="margin-bottom-50">
                                      <div class="table-responsive">
                                          <div id="table-scroll" class="table-scroll">
                                              <div class="table-wrap">
                                                  <table
                                                      class="table table-hover compact cell-border nowrap stripe main-table"
                                                      style="cursor: pointer;">
                                                      <thead>
                                                          <tr>
                                                              <th style="width:5px">
                                                                  <div class="md-checkbox">
                                                                      <input id="selectAllAccess"
                                                                          class="md-checkbox"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          type="checkbox"
                                                                          [(ngModel)]="selectAllAccess"
                                                                          (change)="selectAllUsersForAllAgenda($event);" />
                                                                      <label for="selectAllAccess">&nbsp;</label>
                                                                  </div>
                                                              </th>
                                                              <!-- <th style="width:5px">Prefix</th> -->
                                                              <th style="width:5px">Agenda Number</th>
                                                              <th style="white-space: normal;width:600px">Agenda
                                                                  Title
                                                              </th>
                                                              <!-- <th *ngFor="let dir of Directors">
                                                                  {{dir.DirectorName}}
                                                              </th>
                                                              <th *ngFor="let mem of Member">
                                                                  {{mem.MemberName}}
                                                              </th> -->
                                                              <th *ngFor="let inv of Invitees">
                                                                  {{inv.InviteeName}}
                                                              </th>
                                                          </tr>
                                                      </thead>
                                                      <tbody>
                                                          <tr>
                                                              <td style="width:5px"></td>
                                                              <!-- <td style="width:5px"></td> -->
                                                              <td style="width:5px"></td>
                                                              <td style="white-space: normal;width:600px"></td>
                                                              <!-- <td *ngFor="let dir of Directors; let ind = index">
                                                                  <div class="md-checkbox">
                                                                      <input id="selectDirForAll_{{ind+1}}" class="md-checkbox" [ngModelOptions]="{standalone: true}" type="checkbox" [(ngModel)]="dir.selectDirForAll"
                                                                          (change)="selectIndividualUsersForAllAgenda($event);"
                                                                      />
                                                                      <label for="selectDirForAll_{{ind+1}}">&nbsp;</label>
                                                                  </div>
                                                              </td>
                                                              <td *ngFor="let mem of Member; let ind = index">
                                                                  <div class="md-checkbox">
                                                                      <input id="selectMemForAll_{{ind+1}}" class="md-checkbox" [ngModelOptions]="{standalone: true}" type="checkbox" [(ngModel)]="mem.selectMemForAll"
                                                                          (change)="selectIndividualUsersForAllAgenda($event);"
                                                                      />
                                                                      <label for="selectMemForAll_{{ind+1}}">&nbsp;</label>
                                                                  </div>
                                                              </td> -->
                                                              <td *ngFor="let inv of Invitees; let ind = index">
                                                                  <div class="md-checkbox">
                                                                      <input id="selectInvForAll_{{ind+1}}"
                                                                          class="md-checkbox"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          type="checkbox"
                                                                          [(ngModel)]="inv.selectInvForAll"
                                                                          (change)="selectIndividualUsersForAllAgenda($event, inv._id, ind);" />
                                                                      <label
                                                                          for="selectInvForAll_{{ind+1}}">&nbsp;</label>
                                                                  </div>
  
                                                              </td>
                                                          </tr>
                                                          <tr
                                                              *ngFor="let agenda of agendaAccessArray;let count=index">
  
                                                              <td style="width:5px">
                                                                  <div class="md-checkbox">
                                                                      <input id="selectAgenda{{count +1 }}"
                                                                          type="checkbox"
                                                                          [(ngModel)]="agenda.selectAccessAgenda"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          (change)="selectAllUsersPerAgenda($event, count)">
                                                                      <label
                                                                          for="selectAgenda{{count +1 }}">&nbsp;</label>
  
                                                                  </div>
                                                              </td>
                                                              <!-- <td style="width:5px">{{agenda.agendaNumberPrefix}}</td> -->
                                                              <td style="width:5px">{{agenda.AgendaNumber}}</td>
                                                              <td style="white-space: normal;width:600px">
                                                                  {{agenda.AgendaTitle}}</td>
                                                              <td
                                                                  *ngFor="let accessRights of agenda.AgendaAccessRights; let ind=index">
                                                                  <div class="md-checkbox">
                                                                      <input
                                                                          id="selectAgendaDirectorAccesscheckbox_{{count +1}}_{{ind+1}}"
                                                                          type="checkbox"
                                                                          [(ngModel)]="accessRights.View"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          (change)="selectIndividualUserAccess($event, count, ind, accessRights.LocalCollectionId)">
                                                                      <label
                                                                          for="selectAgendaDirectorAccesscheckbox_{{count +1}}_{{ind+1}}"></label>
                                                                  </div>
                                                              </td>
  
                                                              <!-- <td>
                                                                      <div class="md-checkbox">
                                                                          <input id="selectAgendaInviteeAccesscheckbox_{{count +1}}" type="checkbox" [(ngModel)]="View" [ngModelOptions]="{standalone: true}"
                                                                              (change)="selectIndividualUserAccess($event,  count)">
                                                                          <label for="selectAgendaInviteeAccesscheckbox_{{count +1}}"></label>
                                                                      </div>
                                                                  </td>
                                                                  <td tabindex="1">
                                                                      <div class="md-checkbox">
                                                                          <input id="selectAgendaMemberAccesscheckbox_{{count +1}}" type="checkbox" [(ngModel)]="View" [ngModelOptions]="{standalone: true}"
                                                                              (change)="selectIndividualUserAccess($event, count)">
                                                                          <label for="selectAgendaMemberAccesscheckbox_{{count +1}}"></label>
                                                                      </div>
                                                                  </td> -->
  
                                                          </tr>
                                                      </tbody>
                                                  </table>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button id="btnsaveAgenda" type="button" (click)="updateAgendaAccess()"
                          class="btn-sm btn btn-primary" [disabled]="Invitees.length == 0">
                          <i class="fa fa-save"></i>&nbsp;Update Access
                      </button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal"
                          (click)="closeAccessRightsPopUp()">
                          <i class="fa fa-times"></i>&nbsp;Close
                      </button>
                  </div>
              </div>
          </div>
      </div>
  
      <!-- Model For Automatic Meeting Number Message  START -->
      <div class="modal fade" id="automaticMeetingNumberMessage" tabindex="-1" role="dialog"
          data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">
                          <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                      <!-- <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                              <i class="fa fa-times"></i>
                          </button> -->
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-sm-12">
                              <!-- You have selected dates between the other meeting date. So If you add a meeting
                              number, then another meeting number the above selected date will be added sequential
                              order. -->
                              Meeting number or Meeting date is not in sequence. Do you want system to automatically set the meeting number?
                          </div>
                          <div class="col-md-4">
                              <div class="md-radio md-radio-inline">
                                  <input id="IsSequenseTue" type="radio" style="position:absolute"
                                      name="IsSequenseMeetingNumber" [(ngModel)]="IsSequenseMeetingNumber"
                                      [value]="true" class="form-check-input">
                                  <label for="IsSequenseTue">Yes</label>
                              </div>
                              <div class="md-radio md-radio-inline">
                                  <input id="IsSequenseFalse" type="radio" style="position:absolute"
                                      name=" IsSequenseMeetingNumber" [(ngModel)]="IsSequenseMeetingNumber"
                                      [value]="false" class="form-check-input">
                                  <label for="IsSequenseFalse">No</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger"
                          (click)="changeMeetingNumberInSubsequent()" data-dismiss="modal">
                          <i class="fa fa-check"></i>&nbsp;OK</button>
                  </div>
              </div>
          </div>
      </div>
      <!-- Model For Automatic Meeting Number Message  END -->
  
      <div class="modal fade" id="publishAgendaDialog" tabindex="-1" role="dialog" data-backdrop="static"
          data-keyboard="false" aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabelForDelete">
                          <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                          <i class="fa fa-times"></i>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-sm-12">
                              Do you want to send agenda notification again?
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger" (click)="sendNotification('TransferToGem')"
                          data-dismiss="modal">
                          <i class="fa fa-check"></i>&nbsp;Yes</button>
                      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="clearAgendaQueue()">
                          <i class="fa fa-times"></i>&nbsp;No</button>
                  </div>
              </div>
          </div>
      </div>
  
      <div class="modal fade modal-size-large" id="reminderDialog" tabindex="-1" role="dialog" aria-labelledby=""
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <form [formGroup]="reminderMasterForm" class="well">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="reminderModalLabel">Email Templates</h5>
              <button aria-label="Close" class="close" data-dismiss="modal"
                type="button">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
  
              <div class="row" [hidden]="!IsUpsiEmail">
                <div class="col-md-1">
                  <label class="form-control-label" for="l0">To
                  </label>
                </div>
                <div class="col-md-11">
                  <div class="form-group">
                    Select on of them:<span> (Sharer, Recipient, Data entry person, ADMIN, UPSI All data)</span>
                    <input class="emailTo" name="emailTo" type="text">
                  </div>
                </div>
              </div>
  
              <div class="row" [hidden]="!IsUpsiEmail">
                <div class="col-md-1">
                  <label class="form-control-label" for="l0">CC
                  </label>
                </div>
                <div class="col-md-11">
                  <div class="form-group">
                    Select on of them:<span> (Sharer, Recipient, Data entry person, ADMIN, UPSI All data)</span>
                    <input class="emailCC" name="emailCC" type="text">
                  </div>
                </div>
              </div>
  
  
              <div class="row">
                <div class="col-md-1">
                  <label class="form-control-label" for="l0">Title
                  </label>
                </div>
                <div class="col-md-11">
                  <div class="form-group">
                    <input [formControl]="reminderMasterForm.controls['Title']" class="form-control"
                      placeholder="Email Title">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1">
                  <label class="form-control-label" for="l0">Subject
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </label>
                </div>
                <div class="col-md-11">
                  <div class="form-group">
                    <input [formControl]="reminderMasterForm.controls['Subject']" class="form-control"
                      placeholder="Email Subject">
                    <div
                      *ngIf="reminderMasterForm.controls['Subject'].hasError('required') && reminderMasterForm.controls['Subject'].touched"
                      class="form-control-error-custom">
                      Email Subject is required.
                    </div>
  
                  </div>
                </div>
              </div>
              <div class="row" [hidden]="true" >
                <div class="col-md-1">
                  <label class="form-control-label" for="l0">Attachment
                  </label>
                </div>
                <div class="col-md-11">
                  <div class="form-group">
  
                    <input name="Attachment" class='form-control' type="file" (change)="fileChanged($event)">
                  </div>
                </div>
              </div>
  
              <div class="row" [hidden]="true" >
                <div class="col-lg-1" *ngIf="DocumentFileDoc">
                  <label class="form-control-label">Document</label>
                </div>
                <div class="col-lg-11" *ngIf="DocumentFileDoc">
                  <div class="form-group">
  
                  <a class="btn btn-sm btn-default"><span
                      (click)="downloadFile()">{{FileNameO }}</span>&nbsp;<span (click)="downloadFile()"
                      style="margin-left: 10px"><i class="fa fa-download"></i></span><span
                      (click)="deleteFile()" style="margin-left: 10px"><i class="fa fa-close"
                        style="color: white"></i></span></a>
                    </div>
  
                </div>
              </div>
  
              <div class="row" [hidden]="true">
  
                <div class="col-md-1">
                  <label class="form-control-label" for="l0">Email Text </label>
                </div>
                <div class="col-md-11">
                  <div class="form-group">
  
                    <textarea [formControl]="reminderMasterForm.controls['EmailText']" class="form-control"
                      rows="3">
                    </textarea>
                  </div>
                </div>
              </div>
  
              <div class="row">
                <div class="col-md-1">
                  <label class="form-control-label" for="l0">Body
                  </label>
                </div>
                <div class="col-md-11">
                  <div class="form-group">
                    <div class="summernote"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button id="btnupdateReminder" style="display:none;" type="button" class="btn btn-sm btn-primary"
                [disabled]="!reminderMasterForm.valid || disabledOnclick" (click)="editReminder()">
                <i class="fa fa-save"></i>&nbsp;Update
              </button>
              <button type="button" class="btn btn-sm" data-dismiss="modal">
                <i class="fa fa-times"></i>&nbsp;Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>
  </section>
  <app-alert></app-alert>
  